var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 721.053,
    height: 700.189,
    viewBox: "0 0 721.053 700.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21628",
    "data-name": "Group 21628",
    transform: "translate(-39 -231.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21627",
    "data-name": "Group 21627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(39 238.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20779",
    "data-name": "Group 20779",
    transform: "translate(636.822 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90728",
    "data-name": "Path 90728",
    d: "M489.081,85.969c1.537,11.134-6.765,18.938-24.066,21.324l-34.787,4.8-8.884-64.418,32.945-4.545c16.932-2.335,26.168,3.425,27.538,13.364a15.355,15.355,0,0,1-6.719,15.181C482.731,73.246,488,78.146,489.081,85.969ZM441.2,58.343l1.714,12.424,12.517-1.727c6.074-.837,8.911-3.386,8.34-7.526-.558-4.048-3.98-5.735-10.054-4.9Zm29.2,28.141c-.61-4.418-4.213-6.079-10.472-5.216l-15.277,2.107,1.8,13.067,15.278-2.107C467.985,93.472,471.006,90.9,470.4,86.483Z",
    transform: "translate(-421.344 -42.61)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20783",
    "data-name": "Group 20783",
    transform: "translate(32.418 414.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20780",
    "data-name": "Group 20780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234",
    "data-name": "Rectangle 6234",
    width: 69.991,
    height: 11.091,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20781",
    "data-name": "Group 20781",
    transform: "translate(0 40.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6235",
    "data-name": "Rectangle 6235",
    width: 69.991,
    height: 11.091,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20782",
    "data-name": "Group 20782",
    transform: "translate(0 20.888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236",
    "data-name": "Rectangle 6236",
    width: 34.995,
    height: 11.091,
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20786",
    "data-name": "Group 20786",
    transform: "translate(233.998 464.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20784",
    "data-name": "Group 20784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90729",
    "data-name": "Path 90729",
    d: "M219.6,381.293H165.885V337.171h27.827v9.306H175.191v25.51H210.3v-9.274H219.6Z",
    transform: "translate(-165.885 -337.171)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20785",
    "data-name": "Group 20785",
    transform: "translate(30.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90730",
    "data-name": "Path 90730",
    d: "M239.251,381.293h-22.9v-9.306h13.6v-25.51H194.838v11.882h-9.306V337.171h53.718Z",
    transform: "translate(-185.532 -337.171)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20787",
    "data-name": "Group 20787",
    transform: "translate(698.758 134.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90731",
    "data-name": "Path 90731",
    d: "M473.628,128.038h9.289l-13.006,65.03h-9.289Z",
    transform: "translate(-460.622 -128.038)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20838",
    "data-name": "Group 20838",
    transform: "translate(0 58.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20834",
    "data-name": "Group 20834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20791",
    "data-name": "Group 20791",
    transform: "translate(11.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20790",
    "data-name": "Group 20790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20789",
    "data-name": "Group 20789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20788",
    "data-name": "Group 20788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90732",
    "data-name": "Path 90732",
    d: "M25.011,79.462H169.917v210.1H26Z",
    transform: "translate(-25.011 -79.462)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20798",
    "data-name": "Group 20798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20794",
    "data-name": "Group 20794",
    transform: "translate(0.988 0.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20793",
    "data-name": "Group 20793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20792",
    "data-name": "Group 20792"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6237",
    "data-name": "Rectangle 6237",
    width: 143.587,
    height: 208.124,
    transform: "translate(143.587 208.124) rotate(180)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20797",
    "data-name": "Group 20797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20796",
    "data-name": "Group 20796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20795",
    "data-name": "Group 20795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90733",
    "data-name": "Path 90733",
    d: "M163.053,79.462v210.1H17.491V79.462Zm-1.974,208.124V81.436H19.465v206.15Z",
    transform: "translate(-17.491 -79.462)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20808",
    "data-name": "Group 20808",
    transform: "translate(18.355 23.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20802",
    "data-name": "Group 20802",
    transform: "translate(0.472 0.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20801",
    "data-name": "Group 20801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20800",
    "data-name": "Group 20800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20799",
    "data-name": "Group 20799"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6238",
    "data-name": "Rectangle 6238",
    width: 107.908,
    height: 163.041,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20807",
    "data-name": "Group 20807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20806",
    "data-name": "Group 20806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20805",
    "data-name": "Group 20805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20804",
    "data-name": "Group 20804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20803",
    "data-name": "Group 20803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90734",
    "data-name": "Path 90734",
    d: "M29.6,94.533s.017.281.027.8c.006.552.016,1.32.028,2.318.013,2.067.032,5.065.057,8.955.03,7.831.073,19.217.128,33.6.057,28.753.137,69.45.232,117.366L29.6,257.1l107.894-.043h.013l-.512.514c.039-61.5.076-118.208.1-163.042l.408.41L59,94.729l-21.71-.106-5.705-.046c-1.293-.014-1.979-.044-1.979-.044s.628-.028,1.892-.044q1.956-.014,5.629-.046l21.619-.1c18.81-.052,45.822-.125,78.766-.216h.41v.41c.03,44.833.066,101.538.106,163.042v.514H137.5L29.6,258.046h-.473l0-.471c.095-48.044.175-88.847.232-117.675.054-14.335.1-25.686.126-33.493.025-3.848.044-6.815.057-8.859.013-.976.022-1.727.028-2.266C29.585,94.777,29.6,94.533,29.6,94.533Z",
    transform: "translate(-29.131 -94.123)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20813",
    "data-name": "Group 20813",
    transform: "translate(0.576 186.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20812",
    "data-name": "Group 20812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20811",
    "data-name": "Group 20811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20810",
    "data-name": "Group 20810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20809",
    "data-name": "Group 20809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90735",
    "data-name": "Path 90735",
    d: "M17.865,220.322c-.112-.087.781-1.448,2.316-3.578s3.718-5.029,6.224-8.159,4.876-5.885,6.651-7.824,2.946-3.072,3.051-2.98c.218.194-3.909,5.2-8.9,11.448S18.1,220.505,17.865,220.322Z",
    transform: "translate(-17.856 -197.776)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20818",
    "data-name": "Group 20818",
    transform: "translate(0.978 0.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20817",
    "data-name": "Group 20817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20816",
    "data-name": "Group 20816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20815",
    "data-name": "Group 20815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20814",
    "data-name": "Group 20814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90736",
    "data-name": "Path 90736",
    d: "M18.12,80.09c.224-.175,4.4,4.727,9.322,10.951s8.741,11.415,8.518,11.59-4.4-4.726-9.324-10.951S17.9,80.266,18.12,80.09Z",
    transform: "translate(-18.111 -80.085)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20828",
    "data-name": "Group 20828",
    transform: "translate(125.779 1.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20822",
    "data-name": "Group 20822",
    transform: "translate(0.009 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20821",
    "data-name": "Group 20821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20820",
    "data-name": "Group 20820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20819",
    "data-name": "Group 20819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90737",
    "data-name": "Path 90737",
    d: "M116.069,80.193q-9.4,11.6-18.807,23.205",
    transform: "translate(-97.262 -80.193)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20827",
    "data-name": "Group 20827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20826",
    "data-name": "Group 20826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20825",
    "data-name": "Group 20825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20824",
    "data-name": "Group 20824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20823",
    "data-name": "Group 20823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90738",
    "data-name": "Path 90738",
    d: "M97.265,103.4c-.221-.18,3.811-5.519,9-11.926s9.583-11.458,9.8-11.279-3.81,5.517-9,11.926S97.486,103.578,97.265,103.4Z",
    transform: "translate(-97.257 -80.19)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20833",
    "data-name": "Group 20833",
    transform: "translate(126.92 186.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20832",
    "data-name": "Group 20832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20831",
    "data-name": "Group 20831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20830",
    "data-name": "Group 20830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20829",
    "data-name": "Group 20829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90739",
    "data-name": "Path 90739",
    d: "M115.635,220.238c-.222.177-4.354-4.675-9.226-10.836s-8.643-11.3-8.419-11.475,4.352,4.675,9.226,10.838S115.857,220.061,115.635,220.238Z",
    transform: "translate(-97.98 -197.922)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20837",
    "data-name": "Group 20837",
    transform: "translate(46.598 67.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20836",
    "data-name": "Group 20836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20835",
    "data-name": "Group 20835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90740",
    "data-name": "Path 90740",
    d: "M80.183,162.064H61.194l-2.26,5.234a11.624,11.624,0,0,0-1.112,4.321,3.593,3.593,0,0,0,1.824,3.33q1.071.634,5.273.951v1.467H47.042V175.9a7.986,7.986,0,0,0,4.756-2.4q1.864-1.963,4.6-8.107L75.623,122.5h.754l19.386,44.083q2.774,6.263,4.559,7.889a6.218,6.218,0,0,0,3.807,1.427v1.467H78.122V175.9h1.071a8.143,8.143,0,0,0,4.4-.872,2.121,2.121,0,0,0,.872-1.824,4.845,4.845,0,0,0-.238-1.467q-.08-.357-1.189-2.972Zm-1.348-2.933-8.007-18.514L62.58,159.131Z",
    transform: "translate(-47.042 -122.5)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20848",
    "data-name": "Group 20848",
    transform: "translate(279.433 547.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20842",
    "data-name": "Group 20842",
    transform: "translate(27.178 70.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20841",
    "data-name": "Group 20841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20840",
    "data-name": "Group 20840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20839",
    "data-name": "Group 20839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90741",
    "data-name": "Path 90741",
    d: "M217.417,489.418c-2.559-2.193-8.269-9.147-3.865-17.237,1.613-2.966,5.041-4.433,8.144-5.738s6.364-2.443,8.931-4.627c4.843-4.12,6.178-10.964,9.392-16.459,3.69-6.309,10.578-11.035,17.855-10.705,8.332.38,15.281,7.186,18.432,14.946s3.261,16.376,3.326,24.755c.036,4.634-.17,9.857-3.572,12.987-3.136,2.886-7.859,2.92-12.11,2.789l-45.537-1.4",
    transform: "translate(-211.934 -434.636)",
    fill: "#f5f5f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20847",
    "data-name": "Group 20847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20846",
    "data-name": "Group 20846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20845",
    "data-name": "Group 20845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20844",
    "data-name": "Group 20844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20843",
    "data-name": "Group 20843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90742",
    "data-name": "Path 90742",
    d: "M314.456,389.966H194.7L216.271,518.6a14.361,14.361,0,0,0,10.224,11.451c.139.044.281.076.419.115.356.091.7.213,1.066.276a15.1,15.1,0,0,0,2.436.279l.019.125.585-.093H284.4a15.1,15.1,0,0,0,2.933-.292,14.424,14.424,0,0,0,12.115-12.572l10.4-88.629.468-3.524h-.055l4.119-35.1Zm-22.593,82.051H279.574l1.239-37.331h14.239Zm4.384-37.331h11.765l-4.381,37.331H293.056ZM261.134,513.4l-.746-32.431h17.7L277.008,513.4ZM242,480.97h17.2l.747,32.431H244.522ZM243.33,513.4H228.912c-1.37-8.756-3.152-20.137-5.082-32.431h16.98ZM241.3,472.017l-2.9-37.331h19.727l.861,37.331Zm18.877,0-.861-37.331h20.3l-1.239,37.331Zm-1.066-46.284-.8-34.571h22.749l-1.148,34.571Zm-1.189,0H237.708l-2.687-34.571H257.13Zm-21.409,0H215.126c-.757-4.773-1.476-9.294-2.124-13.361-2.231-13.977-3.07-19.233-3.535-21.21H233.83Zm.7,8.953,2.9,37.331H222.423c-.594-3.788-1.2-7.619-1.8-11.453-1.386-8.813-2.775-17.623-4.079-25.878ZM221.22,472.017H209.665L203.4,434.686h11.935C217.163,446.222,219.186,459.063,221.22,472.017Zm1.407,8.953c1.761,11.223,3.494,22.287,5.082,32.431H216.6l-5.439-32.431ZM278.2,513.4l1.077-32.431H291.1L288.327,513.4Zm2.911-87.669,1.15-34.571h16.511l-2.953,34.571Zm-72.777-34.571c.475,2.5,2.662,16.1,5.588,34.571H201.9l-5.8-34.571ZM298.775,513.4h-9.255l2.771-32.431H302.58Zm10.286-87.669h-12.05l2.953-34.571h13.154Z",
    transform: "translate(-194.699 -389.966)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Window",
    transform: "translate(124.366 231.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20959",
    "data-name": "Group 20959",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20954",
    "data-name": "Group 20954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20852",
    "data-name": "Group 20852",
    transform: "translate(0.411 0.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6239",
    "data-name": "Rectangle 6239",
    width: 518.18,
    height: 399.655,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20853",
    "data-name": "Group 20853",
    transform: "translate(30.856 253.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6240",
    "data-name": "Rectangle 6240",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20854",
    "data-name": "Group 20854",
    transform: "translate(30.641 235.454)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6241",
    "data-name": "Rectangle 6241",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20855",
    "data-name": "Group 20855",
    transform: "translate(30.641 217.444)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6242",
    "data-name": "Rectangle 6242",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20856",
    "data-name": "Group 20856",
    transform: "translate(30.641 199.434)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6243",
    "data-name": "Rectangle 6243",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20857",
    "data-name": "Group 20857",
    transform: "translate(30.856 271.632)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6244",
    "data-name": "Rectangle 6244",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20858",
    "data-name": "Group 20858",
    transform: "translate(30.856 288.986)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6245",
    "data-name": "Rectangle 6245",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20859",
    "data-name": "Group 20859",
    transform: "translate(30.856 307.051)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6246",
    "data-name": "Rectangle 6246",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20860",
    "data-name": "Group 20860",
    transform: "translate(30.856 324.234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6247",
    "data-name": "Rectangle 6247",
    width: 445.115,
    height: 13.396,
    transform: "translate(0 0)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20861",
    "data-name": "Group 20861",
    transform: "translate(30.856 340.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6248",
    "data-name": "Rectangle 6248",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20862",
    "data-name": "Group 20862",
    transform: "translate(30.856 359.509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6249",
    "data-name": "Rectangle 6249",
    width: 445.115,
    height: 13.396,
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20863",
    "data-name": "Group 20863",
    transform: "translate(0.411 0.007)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6250",
    "data-name": "Rectangle 6250",
    width: 518.688,
    height: 29.746,
    fill: "#f0ac20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20867",
    "data-name": "Group 20867",
    transform: "translate(33.464 59.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20864",
    "data-name": "Group 20864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90745",
    "data-name": "Path 90745",
    d: "M96.059,76.723H92.85V75.561h7.741v1.162H97.382v8.195H96.059Z",
    transform: "translate(-92.85 -75.561)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20865",
    "data-name": "Group 20865",
    transform: "translate(7.612 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90746",
    "data-name": "Path 90746",
    d: "M97.677,80.569a3.683,3.683,0,1,1,3.69,3.622A3.525,3.525,0,0,1,97.677,80.569Zm6.069,0a2.388,2.388,0,1,0-2.379,2.5A2.324,2.324,0,0,0,103.746,80.569Z",
    transform: "translate(-97.677 -76.96)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20866",
    "data-name": "Group 20866",
    transform: "translate(19.736 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90747",
    "data-name": "Path 90747",
    d: "M105.366,77.868a.893.893,0,0,1,.91-.908.879.879,0,0,1,.883.908.892.892,0,0,1-.883.924A.906.906,0,0,1,105.366,77.868Zm0,5.4a.894.894,0,0,1,.91-.91.88.88,0,0,1,.883.91.891.891,0,0,1-.883.922A.905.905,0,0,1,105.366,83.269Z",
    transform: "translate(-105.366 -76.96)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20877",
    "data-name": "Group 20877",
    transform: "translate(30.866 106.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20875",
    "data-name": "Group 20875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20868",
    "data-name": "Group 20868",
    transform: "translate(0 0.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90748",
    "data-name": "Path 90748",
    d: "M91.2,114.153l.489-1.033a4.773,4.773,0,0,0,3.058,1.072c1.6,0,2.288-.623,2.288-1.429,0-2.263-5.609-.834-5.609-4.273,0-1.429,1.11-2.646,3.545-2.646a5.459,5.459,0,0,1,2.977.82l-.437,1.058a4.8,4.8,0,0,0-2.54-.754c-1.574,0-2.249.662-2.249,1.468,0,2.263,5.609.847,5.609,4.248,0,1.414-1.139,2.632-3.584,2.632A5.5,5.5,0,0,1,91.2,114.153Z",
    transform: "translate(-91.202 -105.844)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20869",
    "data-name": "Group 20869",
    transform: "translate(8.802 3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90749",
    "data-name": "Path 90749",
    d: "M103.385,107.337v7.012h-1.2v-1.058a2.849,2.849,0,0,1-2.379,1.137,2.755,2.755,0,0,1-3.017-3.056v-4.035h1.269v3.89c0,1.375.688,2.064,1.892,2.064a2.063,2.063,0,0,0,2.17-2.329v-3.625Z",
    transform: "translate(-96.784 -107.337)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20870",
    "data-name": "Group 20870",
    transform: "translate(17.814 0.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90750",
    "data-name": "Path 90750",
    d: "M109.762,111.868a3.414,3.414,0,0,1-3.545,3.586,2.962,2.962,0,0,1-2.5-1.191v1.112H102.5v-9.816h1.269v3.863a2.987,2.987,0,0,1,2.449-1.124A3.4,3.4,0,0,1,109.762,111.868Zm-1.284,0a2.364,2.364,0,1,0-2.368,2.476A2.31,2.31,0,0,0,108.478,111.868Z",
    transform: "translate(-102.499 -105.559)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20871",
    "data-name": "Group 20871",
    transform: "translate(24.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90751",
    "data-name": "Path 90751",
    d: "M106.679,117.669l.412-.979a1.606,1.606,0,0,0,1.031.331c.673,0,1.044-.424,1.044-1.23v-7.356h1.271v7.329a2.092,2.092,0,0,1-2.236,2.327A2.489,2.489,0,0,1,106.679,117.669Zm2.263-11.4a.836.836,0,0,1,.859-.833.828.828,0,1,1-.859.833Z",
    transform: "translate(-106.679 -105.433)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20872",
    "data-name": "Group 20872",
    transform: "translate(29.93 2.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90752",
    "data-name": "Path 90752",
    d: "M117.142,111.29h-5.689a2.376,2.376,0,0,0,2.54,2.051,2.623,2.623,0,0,0,2.025-.847l.7.82a3.822,3.822,0,0,1-6.535-2.449,3.433,3.433,0,0,1,3.52-3.57,3.38,3.38,0,0,1,3.466,3.611C117.169,111.013,117.154,111.17,117.142,111.29Zm-5.689-.913h4.5a2.264,2.264,0,0,0-4.5,0Z",
    transform: "translate(-110.183 -107.296)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20873",
    "data-name": "Group 20873",
    transform: "translate(38.018 2.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90753",
    "data-name": "Path 90753",
    d: "M115.312,110.866a3.5,3.5,0,0,1,3.7-3.57,3.122,3.122,0,0,1,2.857,1.495l-.967.621a2.182,2.182,0,0,0-1.9-1.006,2.469,2.469,0,0,0,0,4.936,2.185,2.185,0,0,0,1.9-1.006l.967.609a3.138,3.138,0,0,1-2.857,1.507A3.513,3.513,0,0,1,115.312,110.866Z",
    transform: "translate(-115.312 -107.296)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20874",
    "data-name": "Group 20874",
    transform: "translate(45.299 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90754",
    "data-name": "Path 90754",
    d: "M124.877,114.5a2.407,2.407,0,0,1-1.536.489,2,2,0,0,1-2.222-2.2v-3.849h-1.191V107.9h1.191v-1.534h1.269V107.9H124.4v1.045h-2.012v3.8a1.033,1.033,0,0,0,1.1,1.176,1.6,1.6,0,0,0,.992-.33Z",
    transform: "translate(-119.929 -106.364)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20876",
    "data-name": "Group 20876",
    transform: "translate(54.583 2.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90755",
    "data-name": "Path 90755",
    d: "M125.817,108.216a.885.885,0,0,1,.9-.9.871.871,0,0,1,.874.9.883.883,0,0,1-.874.913A.9.9,0,0,1,125.817,108.216Zm0,5.344a.885.885,0,0,1,.9-.9.871.871,0,0,1,.874.9.883.883,0,0,1-.874.913A.9.9,0,0,1,125.817,113.56Z",
    transform: "translate(-125.817 -107.316)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20878",
    "data-name": "Group 20878",
    transform: "translate(12.211 11.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90756",
    "data-name": "Path 90756",
    d: "M85.813,48.529a3.221,3.221,0,1,1-3.22-3.222A3.219,3.219,0,0,1,85.813,48.529Z",
    transform: "translate(-79.372 -45.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20879",
    "data-name": "Group 20879",
    transform: "translate(23.675 11.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90757",
    "data-name": "Path 90757",
    d: "M93.082,48.529a3.22,3.22,0,1,1-3.22-3.222A3.22,3.22,0,0,1,93.082,48.529Z",
    transform: "translate(-86.642 -45.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20880",
    "data-name": "Group 20880",
    transform: "translate(35.137 11.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90758",
    "data-name": "Path 90758",
    d: "M100.353,48.529a3.221,3.221,0,1,1-3.222-3.222A3.221,3.221,0,0,1,100.353,48.529Z",
    transform: "translate(-93.911 -45.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20882",
    "data-name": "Group 20882",
    transform: "translate(28.044 151.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20881",
    "data-name": "Group 20881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90759",
    "data-name": "Path 90759",
    d: "M182.839,154.958a3.036,3.036,0,0,1-.022-.375l-.025-1.06q-.019-1.452-.057-4.065c-.03-3.564-.074-8.695-.131-15.162l.235.235-92.972.175h-.006c.82-.82.229-.224.412-.407v2.638q0,1.32,0,2.632v5.212q0,5.175-.006,10.176l-.4-.4,66.2.181,19.6.117,5.3.054c.577.011,1.034.019,1.386.027a3.4,3.4,0,0,1,.489.027,2.593,2.593,0,0,1-.435.025c-.339.008-.781.016-1.337.027l-5.215.054-19.509.117-66.482.181h-.4v-.405q0-4.993,0-10.176,0-2.588,0-5.212V134.3c.183-.184-.41.407.41-.415h.006l92.972.175h.238l0,.236c-.057,6.527-.1,11.7-.131,15.3q-.038,2.578-.057,4.013l-.025,1.019A1.591,1.591,0,0,1,182.839,154.958Z",
    transform: "translate(-89.413 -133.885)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20884",
    "data-name": "Group 20884",
    transform: "translate(127.552 151.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20883",
    "data-name": "Group 20883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90760",
    "data-name": "Path 90760",
    d: "M203.826,154.992a2.4,2.4,0,0,1-.028-.393c-.009-.3-.019-.656-.032-1.093q-.026-1.523-.071-4.138c-.038-3.62-.091-8.737-.156-15.039l.287.287-50.887.123c-.369.367.5-.5.407-.408v2.695l0,2.674q0,2.661,0,5.256c0,3.455-.008,6.812-.013,10.034l-.393-.393,36.38.186,10.622.109,2.865.05a8.494,8.494,0,0,1,1.023.049,6.408,6.408,0,0,1-.927.047l-2.785.05-10.532.109-36.646.186-.393,0v-.4c0-3.222-.009-6.579-.014-10.034q0-2.592,0-5.256v-2.674l0-1.347v-1.348c-.09.087.781-.781.415-.413,19.891.047,37.879.091,50.887.121l.292,0,0,.289c-.065,6.374-.118,11.551-.156,15.212q-.045,2.573-.071,4.073A11.571,11.571,0,0,1,203.826,154.992Z",
    transform: "translate(-152.518 -133.827)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20885",
    "data-name": "Group 20885",
    transform: "translate(34.694 158.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90761",
    "data-name": "Path 90761",
    d: "M96.975,139.449H93.63v-1.213h8.07v1.213H98.354v8.542h-1.38Z",
    transform: "translate(-93.63 -138.236)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20886",
    "data-name": "Group 20886",
    transform: "translate(43.668 157.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90762",
    "data-name": "Path 90762",
    d: "M99.321,138.611a.881.881,0,0,1,.905-.878.871.871,0,1,1-.905.878Zm.238,2.285H100.9v7.384H99.559Z",
    transform: "translate(-99.321 -137.733)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20887",
    "data-name": "Group 20887",
    transform: "translate(46.734 158.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90763",
    "data-name": "Path 90763",
    d: "M106.477,147.284a2.531,2.531,0,0,1-1.616.516,2.109,2.109,0,0,1-2.342-2.315v-4.054h-1.254v-1.1h1.254v-1.616h1.337v1.616h2.119v1.1h-2.119v4a1.09,1.09,0,0,0,1.157,1.241,1.692,1.692,0,0,0,1.045-.348Z",
    transform: "translate(-101.265 -138.714)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20888",
    "data-name": "Group 20888",
    transform: "translate(53.56 157.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90764",
    "data-name": "Path 90764",
    d: "M105.594,137.865h1.337V148.2h-1.337Z",
    transform: "translate(-105.594 -137.865)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20889",
    "data-name": "Group 20889",
    transform: "translate(56.764 160.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90765",
    "data-name": "Path 90765",
    d: "M114.955,143.9h-5.992a2.5,2.5,0,0,0,2.676,2.159,2.753,2.753,0,0,0,2.132-.891l.74.864a4.026,4.026,0,0,1-6.885-2.578,3.617,3.617,0,0,1,3.706-3.762,3.561,3.561,0,0,1,3.652,3.8C114.984,143.61,114.969,143.777,114.955,143.9Zm-5.992-.962H113.7a2.384,2.384,0,0,0-4.738,0Z",
    transform: "translate(-107.626 -139.695)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20890",
    "data-name": "Group 20890",
    transform: "translate(106.66 161.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90766",
    "data-name": "Path 90766",
    d: "M139.269,140.135h8.855l-4.428,4.428Z",
    transform: "translate(-139.269 -140.135)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20891",
    "data-name": "Group 20891",
    transform: "translate(162.854 161.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90767",
    "data-name": "Path 90767",
    d: "M174.905,140.135h8.855l-4.428,4.428Z",
    transform: "translate(-174.905 -140.135)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20893",
    "data-name": "Group 20893",
    transform: "translate(18.974 141.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20892",
    "data-name": "Group 20892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90768",
    "data-name": "Path 90768",
    d: "M566.424,368.151c0-2.419-.117-92.089-.3-240.061l.3.3L84.106,128.5h-.035l.41-.41c-.008,84.619-.016,165.836-.022,240.059l-.388-.386,482.354.388c-3.57,0-200.859.161-482.354.386h-.386v-.388c-.008-74.223-.016-155.44-.024-240.059v-.412h.445l482.319.106h.306v.306C566.543,276.062,566.428,365.735,566.424,368.151Z",
    transform: "translate(-83.661 -127.679)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20895",
    "data-name": "Group 20895",
    transform: "translate(18.243 91.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20894",
    "data-name": "Group 20894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90769",
    "data-name": "Path 90769",
    d: "M566.692,137.295s-.019-.932-.03-2.723-.022-4.451-.038-7.93c-.021-6.957-.052-17.2-.091-30.4l.159.159-483.06.251h-.025l.41-.41v41.054l-.41-.408,342.908.173,102.662.121,27.806.057,7.23.028c1.63.009,2.479.028,2.479.028s-.811.019-2.422.028l-7.176.028c-6.337.013-15.671.033-27.713.057-24.14.03-59.128.071-102.566.123L83.607,137.7H83.2v-.41c0-13.056,0-26.99,0-41.054v-.41h.435l483.06.251h.161v.159c-.039,13.238-.071,23.514-.091,30.492-.017,3.463-.028,6.106-.038,7.9C566.713,136.4,566.692,137.295,566.692,137.295Z",
    transform: "translate(-83.197 -95.831)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20897",
    "data-name": "Group 20897",
    transform: "translate(18.243 41.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20896",
    "data-name": "Group 20896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90770",
    "data-name": "Path 90770",
    d: "M566.692,105.76s-.019-.934-.03-2.723-.022-4.453-.038-7.932c-.021-6.957-.052-17.2-.091-30.4l.159.159c-79.477.043-265.844.139-483.06.252h-.025l.41-.412v41.054l-.41-.408,342.908.173,102.662.121,27.806.058,7.23.028c1.63.009,2.479.028,2.479.028s-.811.019-2.422.028l-7.176.027-27.713.058L426.815,106l-343.208.173H83.2v-.41c0-13.056,0-26.99,0-41.054v-.41h.435l483.06.251h.161V64.7c-.039,13.239-.071,23.514-.091,30.493-.017,3.463-.028,6.1-.038,7.9C566.713,104.866,566.692,105.76,566.692,105.76Z",
    transform: "translate(-83.197 -64.295)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20928",
    "data-name": "Group 20928",
    transform: "translate(194.315 150.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20898",
    "data-name": "Group 20898",
    transform: "translate(178.796 2.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90771",
    "data-name": "Path 90771",
    d: "M311.3,135.313a2.954,2.954,0,0,0-3.051,2.72h0V148.72h.019a4.312,4.312,0,0,0,8.5,0h.021v-8.613h-.831v8.255a3.448,3.448,0,0,1-6.874,0V138.128a2.233,2.233,0,0,1,4.45,0v8.679h.008a1.288,1.288,0,0,1-2.466-.017v-6.683h-.833v6.386h0v.314h.033a2.084,2.084,0,0,0,4.07,0h.017v-.172a1.394,1.394,0,0,0,.016-.142h-.016v-8.46h0A2.954,2.954,0,0,0,311.3,135.313Z",
    transform: "translate(-308.244 -135.313)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20902",
    "data-name": "Group 20902",
    transform: "translate(57.145 7.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20899",
    "data-name": "Group 20899"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6251",
    "data-name": "Rectangle 6251",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20900",
    "data-name": "Group 20900",
    transform: "translate(0 7.011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6252",
    "data-name": "Rectangle 6252",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20901",
    "data-name": "Group 20901",
    transform: "translate(0 3.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6253",
    "data-name": "Rectangle 6253",
    width: 6.079,
    height: 1.927,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20906",
    "data-name": "Group 20906",
    transform: "translate(102.795 7.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20903",
    "data-name": "Group 20903"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6254",
    "data-name": "Rectangle 6254",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20904",
    "data-name": "Group 20904",
    transform: "translate(0 7.011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6255",
    "data-name": "Rectangle 6255",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20905",
    "data-name": "Group 20905",
    transform: "translate(6.079 3.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6256",
    "data-name": "Rectangle 6256",
    width: 6.079,
    height: 1.927,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20910",
    "data-name": "Group 20910",
    transform: "translate(80.288 7.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20907",
    "data-name": "Group 20907"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6257",
    "data-name": "Rectangle 6257",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20908",
    "data-name": "Group 20908",
    transform: "translate(0 7.011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6258",
    "data-name": "Rectangle 6258",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20909",
    "data-name": "Group 20909",
    transform: "translate(0 3.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6259",
    "data-name": "Rectangle 6259",
    width: 12.158,
    height: 1.927,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20914",
    "data-name": "Group 20914",
    transform: "translate(135.463 7.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20911",
    "data-name": "Group 20911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90772",
    "data-name": "Path 90772",
    d: "M290.705,146.553h-9.941v-8.165h5.15v1.722h-3.428v4.721h6.5v-1.716h1.722Z",
    transform: "translate(-280.764 -138.388)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20912",
    "data-name": "Group 20912",
    transform: "translate(5.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90773",
    "data-name": "Path 90773",
    d: "M294.341,146.553H290.1v-1.722h2.516V140.11h-6.5v2.2H284.4v-3.921h9.942Z",
    transform: "translate(-284.4 -138.388)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20913",
    "data-name": "Group 20913",
    transform: "translate(19.701 3.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90774",
    "data-name": "Path 90774",
    d: "M293.258,140.566h5.306l-2.653,2.466Z",
    transform: "translate(-293.258 -140.566)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20915",
    "data-name": "Group 20915",
    transform: "translate(35.427 7.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90775",
    "data-name": "Path 90775",
    d: "M217.324,142.775v-4.581h1.507v4.524c0,1.67.754,2.389,2.064,2.389s2.053-.719,2.053-2.389v-4.524h1.484v4.581c0,2.367-1.334,3.654-3.548,3.654S217.324,145.142,217.324,142.775Z",
    transform: "translate(-217.324 -138.194)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20916",
    "data-name": "Group 20916",
    transform: "translate(19.881 6.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90776",
    "data-name": "Path 90776",
    d: "M209.362,137.615h1.353l-1.9,9.482h-1.355Z",
    transform: "translate(-207.465 -137.615)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20917",
    "data-name": "Group 20917",
    transform: "translate(0 6.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90777",
    "data-name": "Path 90777",
    d: "M203.878,144.5c0,1.638-1.355,2.6-3.9,2.6h-5.12v-9.482h4.849c2.493,0,3.712,1.015,3.712,2.479a2.24,2.24,0,0,1-1.273,2.059A2.394,2.394,0,0,1,203.878,144.5Zm-6.366-4.945v1.829h1.842c.894,0,1.355-.311,1.355-.921s-.46-.908-1.355-.908Zm3.657,4.647c0-.651-.487-.962-1.41-.962h-2.247v1.924h2.247C200.682,145.16,201.169,144.848,201.169,144.2Z",
    transform: "translate(-194.857 -137.615)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20919",
    "data-name": "Group 20919",
    transform: "translate(49.378 0.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20918",
    "data-name": "Group 20918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90778",
    "data-name": "Path 90778",
    d: "M226.583,155.584c-.227,0-.412-4.88-.412-10.9s.185-10.9.412-10.9.41,4.879.41,10.9S226.81,155.584,226.583,155.584Z",
    transform: "translate(-226.171 -133.785)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20921",
    "data-name": "Group 20921",
    transform: "translate(121.641 0.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20920",
    "data-name": "Group 20920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90779",
    "data-name": "Path 90779",
    d: "M272.41,155.584c-.227,0-.412-4.88-.412-10.9s.185-10.9.412-10.9.41,4.879.41,10.9S272.635,155.584,272.41,155.584Z",
    transform: "translate(-271.998 -133.785)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20923",
    "data-name": "Group 20923",
    transform: "translate(165.355 0.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20922",
    "data-name": "Group 20922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90780",
    "data-name": "Path 90780",
    d: "M300.13,155.864c-.227,0-.41-4.88-.41-10.9s.183-10.9.41-10.9.412,4.879.412,10.9S300.357,155.864,300.13,155.864Z",
    transform: "translate(-299.72 -134.065)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20925",
    "data-name": "Group 20925",
    transform: "translate(198.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20924",
    "data-name": "Group 20924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90781",
    "data-name": "Path 90781",
    d: "M321.166,155.453c-.227,0-.412-4.88-.412-10.9s.185-10.9.412-10.9.41,4.879.41,10.9S321.393,155.453,321.166,155.453Z",
    transform: "translate(-320.754 -133.654)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20927",
    "data-name": "Group 20927",
    transform: "translate(34.407 16.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20926",
    "data-name": "Group 20926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90782",
    "data-name": "Path 90782",
    d: "M226.458,144.258c0,.227-2.189.412-4.89.412s-4.891-.184-4.891-.412,2.19-.41,4.891-.41S226.458,144.032,226.458,144.258Z",
    transform: "translate(-216.677 -143.848)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20929",
    "data-name": "Group 20929",
    transform: "translate(139.436 157.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90783",
    "data-name": "Path 90783",
    d: "M163.534,137.615V147.1h-1.34v-8.3h-2.14v-1.178Z",
    transform: "translate(-160.054 -137.506)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90784",
    "data-name": "Path 90784",
    d: "M170.409,145.959v1.178H163.6v-.921l3.86-3.725c1-.976,1.192-1.572,1.192-2.168,0-.975-.691-1.572-2.018-1.572a2.976,2.976,0,0,0-2.424,1.031l-.922-.8a4.372,4.372,0,0,1,3.469-1.436c1.977,0,3.251,1.015,3.251,2.641,0,.922-.271,1.747-1.558,2.98l-2.9,2.791Z",
    transform: "translate(-158.191 -137.546)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20931",
    "data-name": "Group 20931",
    transform: "translate(18.58 182.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20930",
    "data-name": "Group 20930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90785",
    "data-name": "Path 90785",
    d: "M566.569,154.262c0,.227-108.167.41-241.568.41-133.445,0-241.59-.183-241.59-.41s108.145-.412,241.59-.412C458.4,153.85,566.569,154.034,566.569,154.262Z",
    transform: "translate(-83.411 -153.85)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20933",
    "data-name": "Group 20933",
    transform: "translate(33.184 206.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20932",
    "data-name": "Group 20932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90786",
    "data-name": "Path 90786",
    d: "M531.432,169.428c0,.227-98.228.412-219.369.412-121.184,0-219.391-.185-219.391-.412s98.207-.41,219.391-.41C433.2,169.018,531.432,169.2,531.432,169.428Z",
    transform: "translate(-92.672 -169.018)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20935",
    "data-name": "Group 20935",
    transform: "translate(33.184 224.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20934",
    "data-name": "Group 20934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90787",
    "data-name": "Path 90787",
    d: "M531.432,180.7c0,.227-98.228.41-219.369.41-121.184,0-219.391-.183-219.391-.41s98.207-.41,219.391-.41C433.2,180.293,531.432,180.476,531.432,180.7Z",
    transform: "translate(-92.672 -180.293)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20937",
    "data-name": "Group 20937",
    transform: "translate(33.184 242.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20936",
    "data-name": "Group 20936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90788",
    "data-name": "Path 90788",
    d: "M531.432,191.979c0,.227-98.228.41-219.369.41-121.184,0-219.391-.183-219.391-.41s98.207-.412,219.391-.412C433.2,191.567,531.432,191.751,531.432,191.979Z",
    transform: "translate(-92.672 -191.567)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20939",
    "data-name": "Group 20939",
    transform: "translate(33.184 260.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20938",
    "data-name": "Group 20938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90789",
    "data-name": "Path 90789",
    d: "M531.432,203.254c0,.227-98.228.41-219.369.41-121.184,0-219.391-.183-219.391-.41s98.207-.412,219.391-.412C433.2,202.842,531.432,203.027,531.432,203.254Z",
    transform: "translate(-92.672 -202.842)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20941",
    "data-name": "Group 20941",
    transform: "translate(33.184 277.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20940",
    "data-name": "Group 20940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90790",
    "data-name": "Path 90790",
    d: "M531.432,214.529c0,.225-98.228.41-219.369.41-121.184,0-219.391-.184-219.391-.41s98.207-.412,219.391-.412C433.2,214.117,531.432,214.3,531.432,214.529Z",
    transform: "translate(-92.672 -214.117)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20943",
    "data-name": "Group 20943",
    transform: "translate(33.184 295.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20942",
    "data-name": "Group 20942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90791",
    "data-name": "Path 90791",
    d: "M531.432,225.8c0,.227-98.228.412-219.369.412-121.184,0-219.391-.184-219.391-.412s98.207-.41,219.391-.41C433.2,225.392,531.432,225.576,531.432,225.8Z",
    transform: "translate(-92.672 -225.392)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20945",
    "data-name": "Group 20945",
    transform: "translate(33.184 313.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20944",
    "data-name": "Group 20944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90792",
    "data-name": "Path 90792",
    d: "M531.432,237.077c0,.227-98.228.412-219.369.412-121.184,0-219.391-.184-219.391-.412s98.207-.41,219.391-.41C433.2,236.667,531.432,236.851,531.432,237.077Z",
    transform: "translate(-92.672 -236.667)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20947",
    "data-name": "Group 20947",
    transform: "translate(33.502 330.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20946",
    "data-name": "Group 20946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90793",
    "data-name": "Path 90793",
    d: "M531.632,247.949c0,.227-98.228.412-219.369.412-121.184,0-219.389-.185-219.389-.412s98.206-.41,219.389-.41C433.4,247.539,531.632,247.724,531.632,247.949Z",
    transform: "translate(-92.874 -247.539)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20949",
    "data-name": "Group 20949",
    transform: "translate(33.819 347.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20948",
    "data-name": "Group 20948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90794",
    "data-name": "Path 90794",
    d: "M531.833,258.823c0,.225-98.226.41-219.369.41-121.184,0-219.389-.185-219.389-.41s98.206-.412,219.389-.412C433.607,258.411,531.833,258.6,531.833,258.823Z",
    transform: "translate(-93.075 -258.411)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20951",
    "data-name": "Group 20951",
    transform: "translate(34.136 364.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20950",
    "data-name": "Group 20950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90795",
    "data-name": "Path 90795",
    d: "M93.276,269.695c0-.227,98.228-.412,219.369-.412,121.184,0,219.391.185,219.391.412s-98.207.41-219.391.41C191.5,270.1,93.276,269.922,93.276,269.695Z",
    transform: "translate(-93.276 -269.283)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20953",
    "data-name": "Group 20953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20952",
    "data-name": "Group 20952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90796",
    "data-name": "Path 90796",
    d: "M590.218,437.978c0-2.815-.134-158.248-.339-399.655l.339.339c-147.155.02-325.736.046-518.136.071H72.04l.41-.41c-.016,143.965-.03,280.176-.041,399.655l-.369-.369c307.457.218,514.932.366,518.178.369l-518.178.369h-.371v-.369c-.013-119.479-.027-255.691-.041-399.655v-.41h.454l518.136.071h.339v.339C590.352,279.73,590.221,435.167,590.218,437.978Z",
    transform: "translate(-71.628 -37.913)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20958",
    "data-name": "Group 20958",
    transform: "translate(316.024 112.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20955",
    "data-name": "Group 20955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90797",
    "data-name": "Path 90797",
    d: "M272.041,121.147v34.374A11.48,11.48,0,0,0,283.521,167H325.53a3.993,3.993,0,0,1,3.14,1.526L338.979,191l12.432-22.116a3.992,3.992,0,0,1,2.975-1.331H398.48a11.478,11.478,0,0,0,11.478-11.478V120.934a11.477,11.477,0,0,0-11.5-11.478l-114.96.211A11.48,11.48,0,0,0,272.041,121.147Z",
    transform: "translate(-272.041 -109.456)",
    fill: "#f0ac20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20956",
    "data-name": "Group 20956",
    transform: "translate(21.665 16.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90798",
    "data-name": "Path 90798",
    d: "M292.97,144.948H285.78v-6.777l16.554-18.082.333-.09c2.316-.632,4.119-.372,5.363.765,2.091,1.916,1.528,5.44,1.457,5.836l-.061.337Zm-4.813-2.378h3.762l15.267-16.71c.095-.889.079-2.573-.768-3.346-.557-.5-1.492-.61-2.805-.3l-15.456,16.882Z",
    transform: "translate(-285.78 -119.662)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20957",
    "data-name": "Group 20957",
    transform: "translate(62.021 18.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90799",
    "data-name": "Path 90799",
    d: "M325.04,138.835v2.34H311.373V122.346h13.29v2.339h-10.6v5.784h9.444v2.288h-9.444v6.079Z",
    transform: "translate(-311.373 -120.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90800",
    "data-name": "Path 90800",
    d: "M336.387,121.629v19.96H333.91v-2.26a6.021,6.021,0,0,1-5.084,2.421,7.277,7.277,0,0,1,0-14.553,6.073,6.073,0,0,1,4.978,2.286v-7.854Zm-2.558,12.833a4.807,4.807,0,1,0-4.787,5.03A4.692,4.692,0,0,0,333.829,134.462Z",
    transform: "translate(-305.463 -121.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90801",
    "data-name": "Path 90801",
    d: "M333.805,123.068a1.7,1.7,0,0,1,1.749-1.7,1.672,1.672,0,0,1,1.747,1.64,1.749,1.749,0,0,1-3.5.055Zm.457,4.411h2.583v14.258h-2.583Z",
    transform: "translate(-298.433 -121.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90802",
    "data-name": "Path 90802",
    d: "M347.622,139.81a4.867,4.867,0,0,1-3.121,1c-2.879,0-4.519-1.586-4.519-4.466v-7.828h-2.42v-2.126h2.42v-3.119h2.581v3.119h4.089v2.126h-4.089v7.72a2.1,2.1,0,0,0,2.234,2.4,3.26,3.26,0,0,0,2.018-.673Z",
    transform: "translate(-296.265 -120.28)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(117.383 639.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20996",
    "data-name": "Group 20996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20990",
    "data-name": "Group 20990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20961",
    "data-name": "Group 20961",
    transform: "translate(69.856 75.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20960",
    "data-name": "Group 20960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90803",
    "data-name": "Path 90803",
    d: "M115.939,516.73c-4.122-.205-5.336-6.027-3.8-9.859s4.573-7.241,4.615-11.369c.036-3.581-2.239-6.837-2.457-10.412-.393-6.453,5.841-11.711,6.106-18.169.207-5.033-3.286-9.829-2.439-14.794.907-5.33,6.467-8.829,7.742-14.083,1.356-5.593-2.525-11.511-1.038-17.071,1.482-5.541,8.01-9.606,7.08-15.266-.307-1.872-1.435-3.508-1.941-5.336-1.17-4.221,1.134-8.626,3.926-12s6.214-6.369,7.939-10.395c2.651-6.188.809-13.717,3.941-19.676,2.607-4.961,8.406-8.3,9.138-13.854,2.942,5,.065,11.366.735,17.129.437,3.758,2.383,7.146,3.579,10.735a27.958,27.958,0,0,1-2.2,22.369c-2.523,4.431-6.41,8.613-6.213,13.709.24,6.169,6.413,10.642,7.5,16.72,1.56,8.695-7.7,16.513-6.419,25.253.33,2.255,1.361,4.376,1.555,6.647.659,7.725-8.107,13.184-9.439,20.823-.981,5.622,2.269,11.431.926,16.977-1.036,4.275-4.727,8.105-3.821,12.41.394,1.865,1.618,3.436,2.359,5.193a9.906,9.906,0,0,1-1.547,10.243,8.613,8.613,0,0,1-9.961,2.047",
    transform: "translate(-111.499 -344.446)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20964",
    "data-name": "Group 20964",
    transform: "translate(69.856 75.016)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20963",
    "data-name": "Group 20963",
    transform: "translate(8 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20962",
    "data-name": "Group 20962",
    transform: "translate(-8 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90804",
    "data-name": "Path 90804",
    d: "M143.322,512.411c-.741-1.757-1.965-3.327-2.359-5.193-.907-4.3,2.785-8.135,3.821-12.41,1.343-5.546-1.906-11.355-.926-16.977,1.334-7.638,10.1-13.1,9.439-20.823-.194-2.271-1.224-4.392-1.555-6.647-1.282-8.741,7.979-16.559,6.419-25.253-1.09-6.077-7.263-10.551-7.5-16.72-.2-5.1,3.69-9.278,6.213-13.709a27.958,27.958,0,0,0,2.2-22.369c-1.2-3.589-3.143-6.978-3.579-10.735-.67-5.763,2.208-12.129-.735-17.129-.732,5.555-6.531,8.9-9.138,13.854-3.132,5.959-1.29,13.489-3.941,19.676-1.725,4.026-5.147,7.022-7.939,10.395s-5.1,7.779-3.926,12c.506,1.828,1.634,3.464,1.941,5.336.93,5.659-5.6,9.725-7.08,15.266-1.487,5.56,2.394,11.478,1.038,17.071-1.276,5.254-6.836,8.753-7.742,14.083-.847,4.966,2.646,9.761,2.439,14.794-.265,6.457-6.5,11.716-6.106,18.169.218,3.575,2.493,6.831,2.457,10.412-.043,4.128-3.08,7.537-4.615,11.369s-.322,9.654,3.8,9.859l15.874,7.971a8.613,8.613,0,0,0,9.961-2.047A9.906,9.906,0,0,0,143.322,512.411Z",
    transform: "translate(-111.499 -344.446)",
    fill: "#f0ac20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20966",
    "data-name": "Group 20966",
    transform: "translate(73.79 76.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20965",
    "data-name": "Group 20965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90805",
    "data-name": "Path 90805",
    d: "M137.013,507.38c-.863-1.425-1.894-4.417-1.591-6.1.424-2.361,4.415-4.436,5.407-8.439,1.288-5.194-1.034-14.383-.044-19.623,1.344-7.119,8.711-11.8,8.408-18.875-.088-2.078.205-7.635,0-9.69-.787-7.965,6.208-13.312,5.189-21.217-.713-5.525-6.441-12-6.446-17.664,0-4.68,3.349-8.783,5.579-13.028A29.214,29.214,0,0,0,156.037,372c-.878-3.228-2.384-6.222-2.627-9.654-.374-5.264,2.211-11.311-.071-15.725-.781,5.163-5.691,8.613-8.007,13.35-2.782,5.689-1.493,12.5-3.884,18.374-1.556,3.818-4.486,6.8-6.905,10.086s-4.467,7.493-3.631,11.3c.361,1.651,1.244,3.084,1.441,4.789.591,5.15-4.945,9.318-6.347,14.513-1.407,5.218,1.623,10.414.322,15.654-1.222,4.92-6.038,11.6-6.959,16.571-.856,4.626,3.337,7.638,3.007,12.285-.423,5.964-6.4,13.181-6.278,19.1.068,3.278,2.81,4.328,2.666,7.63-.164,3.8-3.348,11.363-4.74,14.99s-1.306,6.427.987,10.209l17.726,8.794C140.65,520.5,140.3,512.8,137.013,507.38Z",
    transform: "translate(-113.106 -346.623)",
    fill: "#03b5aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20969",
    "data-name": "Group 20969",
    transform: "translate(83.152 105.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20968",
    "data-name": "Group 20968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20967",
    "data-name": "Group 20967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90806",
    "data-name": "Path 90806",
    d: "M144.99,363.713a1.638,1.638,0,0,1,.03.394c0,.3.006.678.011,1.151-.008,1.012-.009,2.509-.181,4.431a22.14,22.14,0,0,1-1.6,6.844c-1.042,2.6-3.247,4.931-5.336,7.607a14.1,14.1,0,0,0-2.526,4.627,15.686,15.686,0,0,0-.643,5.674c.191,4,1.424,8.17,2.007,12.714a19.37,19.37,0,0,1-.227,7.05,13.443,13.443,0,0,1-1.389,3.42,31.194,31.194,0,0,0-1.869,3.111c-1.011,2.176-.617,4.735-.106,7.194.255,1.246.536,2.513.686,3.827a15.094,15.094,0,0,1-.1,3.988,31.405,31.405,0,0,1-2.441,7.446,60.514,60.514,0,0,0-2.739,6.973,18.025,18.025,0,0,0-.615,7.08,31.854,31.854,0,0,1,.249,7.03,21.308,21.308,0,0,1-2.238,6.328,24.854,24.854,0,0,0-2.233,5.752c-.749,3.914.361,7.67.281,11.144-.044,3.52-1.213,6.5-2.037,9.08a31.805,31.805,0,0,0-1.731,6.732,9.7,9.7,0,0,0,.446,4.317c.361.932.637,1.4.6,1.414a7.589,7.589,0,0,1-.733-1.364,9.451,9.451,0,0,1-.588-4.392,31.015,31.015,0,0,1,1.629-6.833c.793-2.594,1.9-5.557,1.913-8.958a53,53,0,0,0-.43-5.347,20.026,20.026,0,0,1,.074-5.91c.766-4.108,3.775-7.626,4.4-12.05a31.612,31.612,0,0,0-.276-6.885,18.687,18.687,0,0,1,.621-7.331c1.359-4.828,4.3-9.225,5.148-14.337a14.474,14.474,0,0,0,.1-3.8c-.142-1.261-.416-2.509-.672-3.764-.506-2.463-.957-5.2.162-7.621a30.963,30.963,0,0,1,1.914-3.182,12.709,12.709,0,0,0,1.32-3.229,18.793,18.793,0,0,0,.237-6.807c-.552-4.467-1.774-8.666-1.947-12.765a16.208,16.208,0,0,1,.711-5.869,14.537,14.537,0,0,1,2.649-4.764c2.151-2.7,4.325-4.948,5.371-7.462a22.33,22.33,0,0,0,1.687-6.711c.214-1.9.26-3.4.314-4.406.024-.471.044-.852.058-1.15A1.644,1.644,0,0,1,144.99,363.713Z",
    transform: "translate(-119.932 -363.713)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20971",
    "data-name": "Group 20971",
    transform: "translate(34.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20970",
    "data-name": "Group 20970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90807",
    "data-name": "Path 90807",
    d: "M103.707,546.2c-5.768.844-9.043-6.889-7.965-12.62s4.351-11.284,3.278-17.014c-.93-4.973-4.973-8.86-6.254-13.755-2.312-8.83,4.884-17.823,3.482-26.843-1.091-7.03-7.244-12.716-7.432-19.828-.2-7.632,6.542-14,6.869-21.631.348-8.122-6.648-15.258-6.112-23.369.535-8.081,8.466-15.5,5.628-23.088-.94-2.509-2.95-4.467-4.152-6.863-2.775-5.527-.79-12.26,2.154-17.7s6.866-10.527,8.152-16.578c1.977-9.3-2.637-19.227.069-28.339,2.253-7.585,9.374-13.8,8.865-21.7,5.446,6.121,3.2,15.731,5.711,23.532,1.634,5.085,5.259,9.248,7.9,13.892a39.494,39.494,0,0,1,3.088,31.593c-2.282,6.833-6.524,13.69-4.854,20.7,2.022,8.482,11.8,12.989,14.974,21.11,4.543,11.618-6.147,24.987-1.977,36.746,1.077,3.032,3.086,5.691,3.975,8.783,3.029,10.522-7.619,20.487-7.373,31.433.181,8.058,6.274,15.215,5.932,23.267-.263,6.207-4.33,12.524-1.894,18.24,1.055,2.477,3.182,4.317,4.691,6.549a13.993,13.993,0,0,1,.661,14.616,12.161,12.161,0,0,1-13.241,5.563",
    transform: "translate(-88.812 -296.873)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20974",
    "data-name": "Group 20974",
    transform: "translate(34.081)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20973",
    "data-name": "Group 20973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20972",
    "data-name": "Group 20972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90808",
    "data-name": "Path 90808",
    d: "M140.462,532.712c-1.509-2.231-3.636-4.071-4.691-6.549-2.436-5.715,1.63-12.033,1.894-18.24.342-8.051-5.751-15.209-5.932-23.267-.244-10.947,10.4-20.911,7.373-31.433-.889-3.092-2.9-5.751-3.975-8.783-4.169-11.759,6.52-25.127,1.979-36.746-3.176-8.121-12.954-12.628-14.976-21.11-1.67-7.006,2.572-13.864,4.854-20.7A39.494,39.494,0,0,0,123.9,334.3c-2.64-4.644-6.265-8.807-7.9-13.892-2.507-7.8-.265-17.41-5.711-23.532.509,7.9-6.612,14.113-8.865,21.7-2.706,9.114,1.908,19.041-.069,28.339-1.287,6.05-5.207,11.137-8.152,16.578s-4.929,12.172-2.154,17.7c1.2,2.4,3.212,4.354,4.152,6.863,2.838,7.586-5.093,15.007-5.628,23.088-.536,8.111,6.46,15.247,6.112,23.369-.326,7.627-7.071,14-6.869,21.631.188,7.112,6.341,12.8,7.432,19.828,1.4,9.02-5.793,18.013-3.482,26.843,1.28,4.895,5.324,8.782,6.254,13.755,1.072,5.73-2.2,11.286-3.278,17.014s2.2,13.463,7.965,12.62l24.175,6.694a12.162,12.162,0,0,0,13.241-5.565A13.991,13.991,0,0,0,140.462,532.712Z",
    transform: "translate(-88.812 -296.873)",
    fill: "#f0ac20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20976",
    "data-name": "Group 20976",
    transform: "translate(38.53 2.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20975",
    "data-name": "Group 20975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90809",
    "data-name": "Path 90809",
    d: "M130.748,527.167c-1.586-1.738-3.833-5.6-3.876-8.02-.06-3.387,4.9-7.356,5.18-13.175.361-7.548-5.374-19.643-5.437-27.174-.088-10.232,8.837-18.741,6.479-28.455-.692-2.854-1.807-10.633-2.652-13.424C127.17,426.1,135.4,416.777,131.82,406.1c-2.5-7.459-12.211-14.86-13.769-22.708-1.287-6.483,2.236-13.085,4.161-19.575a41.272,41.272,0,0,0-2.186-29.426c-2.1-4.229-5.008-7.966-6.285-12.654-1.96-7.189-.036-16.276-4.4-21.765.333,7.366-5.527,13.492-7.438,20.688-2.3,8.644,1.356,17.732-.348,26.518-1.11,5.718-4.352,10.649-6.8,15.866s-4.138,11.606-1.935,16.656c.952,2.187,2.569,3.933,3.307,6.24,2.233,6.973-4.3,14.263-4.816,21.847-.52,7.613,5.1,13.984,4.732,21.6-.344,7.151-5.188,17.732-5.1,24.864.08,6.646,6.714,9.669,7.53,16.2,1.049,8.378-5.257,20.012-3.466,28.174.992,4.524,5.079,5.229,5.786,9.841.814,5.314-1.528,16.66-2.463,22.068s-.049,9.259,4.165,13.873l26.966,7.326C139.379,544.344,136.787,533.782,130.748,527.167Z",
    transform: "translate(-90.932 -299.974)",
    fill: "#03b5aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20979",
    "data-name": "Group 20979",
    transform: "translate(49.864 43.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20978",
    "data-name": "Group 20978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20977",
    "data-name": "Group 20977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90810",
    "data-name": "Path 90810",
    d: "M106.054,324.418a68.035,68.035,0,0,1,1.386,8.323,31.3,31.3,0,0,1-.364,9.9,24.874,24.874,0,0,1-2.118,5.836c-.965,1.974-2.138,3.972-3.2,6.137a19.925,19.925,0,0,0-2.252,7.135,22.245,22.245,0,0,0,.656,8.078c1.361,5.513,4.21,10.954,6.254,17.077a27.226,27.226,0,0,1,1.6,9.781,18.821,18.821,0,0,1-.981,5.077,44.053,44.053,0,0,0-1.742,4.838c-.817,3.344.448,6.817,1.829,10.086.694,1.657,1.43,3.334,1.993,5.1a21.3,21.3,0,0,1,.946,5.514,44.216,44.216,0,0,1-1.339,10.948,85.1,85.1,0,0,0-1.886,10.429,26.093,26.093,0,0,0,.046,5.112,28.194,28.194,0,0,0,1.05,4.915c.926,3.2,2.075,6.358,2.269,9.643a29.945,29.945,0,0,1-1.356,9.338,35.235,35.235,0,0,0-1.515,8.614,27.753,27.753,0,0,0,1.44,8.014,74.671,74.671,0,0,1,2.023,7.367,26.867,26.867,0,0,1,.334,6.954c-.142,2.193-.408,4.243-.651,6.155a44.819,44.819,0,0,0-.53,9.818,13.627,13.627,0,0,0,1.834,5.867c.763,1.192,1.28,1.75,1.241,1.78a11.714,11.714,0,0,1-1.362-1.7,13.364,13.364,0,0,1-1.987-5.915,43.872,43.872,0,0,1,.41-9.895c.224-1.914.47-3.959.593-6.131a26.369,26.369,0,0,0-.377-6.834,75.014,75.014,0,0,0-2.053-7.3,28.172,28.172,0,0,1-1.5-8.173,35.657,35.657,0,0,1,1.5-8.769,29.4,29.4,0,0,0,1.307-9.141c-.192-3.157-1.323-6.263-2.266-9.493a28.846,28.846,0,0,1-1.083-5.025,26.781,26.781,0,0,1-.057-5.251A85.283,85.283,0,0,1,108.03,438.1a43.679,43.679,0,0,0,1.32-10.77,20.551,20.551,0,0,0-.913-5.33c-.547-1.717-1.271-3.375-1.968-5.043a31.178,31.178,0,0,1-1.769-5.123,11.818,11.818,0,0,1-.087-5.391,43.641,43.641,0,0,1,1.776-4.915,18.2,18.2,0,0,0,.949-4.877,26.646,26.646,0,0,0-1.548-9.545c-2-6.052-4.843-11.53-6.2-17.139a22.755,22.755,0,0,1-.629-8.283,20.443,20.443,0,0,1,2.346-7.295c1.093-2.181,2.279-4.166,3.25-6.114a24.646,24.646,0,0,0,2.135-5.722,31.579,31.579,0,0,0,.476-9.784c-.235-2.7-.59-4.776-.8-6.189-.106-.68-.188-1.211-.249-1.607A3.416,3.416,0,0,1,106.054,324.418Z",
    transform: "translate(-98.821 -324.418)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20981",
    "data-name": "Group 20981",
    transform: "translate(0 102.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20980",
    "data-name": "Group 20980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90811",
    "data-name": "Path 90811",
    d: "M112.564,512.449c-3.289,1.621-6.744-2.375-7.206-6.013s.424-7.594-1.326-10.817c-1.519-2.8-4.69-4.341-6.4-7.022-3.091-4.839-.522-11.612-3.1-16.74-2.014-4-6.795-6.21-8.282-10.429-1.6-4.529,1.209-9.646-.069-14.275-1.362-4.928-6.929-7.845-8.174-12.8-1.243-4.94,2.07-10.915-1.1-14.906-1.045-1.32-2.629-2.1-3.81-3.3-2.73-2.772-2.843-7.186-2.132-11.01s2.074-7.627,1.675-11.5c-.615-5.948-5.3-11-5.435-16.975-.118-4.975,2.942-10.071,1.112-14.7,4.442,2.611,4.958,8.8,7.966,12.979,1.96,2.728,4.934,4.519,7.413,6.788a24.843,24.843,0,0,1,7.954,18.311c-.046,4.53-1.258,9.455,1.1,13.325,2.849,4.686,9.572,5.494,13.042,9.74,4.964,6.076,1.15,16.142,5.918,22.374,1.23,1.607,2.947,2.81,4.076,4.488,3.848,5.713-.6,13.734,1.664,20.239,1.665,4.787,6.7,7.894,8.047,12.777,1.042,3.767-.17,8.334,2.392,11.282,1.11,1.279,2.739,1.969,4.073,3.013a8.8,8.8,0,0,1,3.22,8.619,7.647,7.647,0,0,1-6.848,5.89",
    transform: "translate(-67.199 -361.958)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20984",
    "data-name": "Group 20984",
    transform: "translate(0 102.63)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20983",
    "data-name": "Group 20983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20982",
    "data-name": "Group 20982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90812",
    "data-name": "Path 90812",
    d: "M131.955,497.275c-1.334-1.044-2.963-1.735-4.073-3.013-2.562-2.949-1.35-7.515-2.392-11.282-1.351-4.885-6.382-7.99-8.047-12.777-2.263-6.5,2.184-14.526-1.664-20.239-1.129-1.678-2.846-2.881-4.076-4.488-4.768-6.232-.954-16.3-5.918-22.374-3.471-4.246-10.193-5.054-13.042-9.74-2.354-3.87-1.142-8.794-1.1-13.325a24.837,24.837,0,0,0-7.954-18.311c-2.479-2.269-5.453-4.06-7.413-6.788-3.009-4.183-3.524-10.368-7.966-12.979,1.831,4.628-1.23,9.725-1.112,14.7.14,5.978,4.822,11.027,5.435,16.975.4,3.87-.963,7.671-1.675,11.5s-.6,8.238,2.132,11.01c1.181,1.2,2.764,1.984,3.811,3.3,3.165,3.991-.148,9.966,1.094,14.906,1.246,4.959,6.812,7.876,8.174,12.8,1.279,4.63-1.526,9.747.069,14.275,1.487,4.22,6.268,6.434,8.282,10.429,2.581,5.128.013,11.9,3.1,16.74,1.712,2.681,4.884,4.226,6.4,7.022,1.75,3.223.864,7.181,1.326,10.817s3.917,7.634,7.206,6.013l15.762-.665a7.647,7.647,0,0,0,6.848-5.89A8.794,8.794,0,0,0,131.955,497.275Z",
    transform: "translate(-67.199 -361.958)",
    fill: "#f0ac20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20986",
    "data-name": "Group 20986",
    transform: "translate(2.463 105.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20985",
    "data-name": "Group 20985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90813",
    "data-name": "Path 90813",
    d: "M125.507,495.616c-1.285-.733-3.378-2.61-3.87-4.051-.691-2.015,1.512-5.349.553-8.886-1.243-4.587-7.012-10.718-8.507-15.212-2.029-6.107,1.667-12.926-1.621-18.284-.967-1.574-3.136-6.013-4.182-7.52-4.049-5.844-.929-13.014-5.133-18.71-2.938-3.982-10.18-6.535-12.629-10.931-2.023-3.63-1.191-8.263-1.293-12.52a25.952,25.952,0,0,0-7-17.188c-2.074-2.126-4.537-3.8-6.207-6.36-2.562-3.923-3.168-9.734-6.844-12.175,1.623,4.344-.7,9.143-.453,13.82.3,5.617,4.239,10.351,4.917,15.939.442,3.636-.546,7.214-1,10.811s-.233,7.746,2.061,10.343c.993,1.124,2.3,1.856,3.185,3.094,2.684,3.742.185,9.368,1.34,14.007,1.159,4.658,5.754,7.383,7.008,12.011,1.175,4.347.322,11.615,1.752,15.868,1.332,3.963,5.886,4.489,7.638,8.239,2.245,4.813.721,12.995,3.37,17.533,1.468,2.515,4.051,2.148,5.364,4.77,1.515,3.024,2.307,10.267,2.793,13.684s1.761,5.552,5.174,7.5l17.555-.826C133.994,504.229,130.4,498.408,125.507,495.616Z",
    transform: "translate(-68.308 -363.781)",
    fill: "#03b5aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20989",
    "data-name": "Group 20989",
    transform: "translate(10.428 128.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20988",
    "data-name": "Group 20988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20987",
    "data-name": "Group 20987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90814",
    "data-name": "Path 90814",
    d: "M73.814,378.255a1.343,1.343,0,0,1,.2.29l.509.888c.434.788,1.08,1.949,1.779,3.515a19.663,19.663,0,0,1,1.722,6.006c.315,2.474-.389,5.24-.853,8.215a12.5,12.5,0,0,0,.039,4.672,13.881,13.881,0,0,0,1.947,4.671c1.875,3.02,4.631,5.719,7.049,9a17.241,17.241,0,0,1,2.875,5.584,11.954,11.954,0,0,1,.4,3.266,27.484,27.484,0,0,0-.107,3.217c.155,2.11,1.556,3.92,3.015,5.607.735.856,1.5,1.72,2.187,2.678a13.5,13.5,0,0,1,1.648,3.149,27.914,27.914,0,0,1,1.321,6.842,53.332,53.332,0,0,0,.883,6.591A15.946,15.946,0,0,0,101,458.191a28.368,28.368,0,0,1,3.229,5.358,18.941,18.941,0,0,1,1,5.89,22.069,22.069,0,0,0,.746,5.421c1.1,3.351,3.583,5.789,5.022,8.525a26.553,26.553,0,0,1,2.335,7.938,28.413,28.413,0,0,0,1.555,5.972,8.6,8.6,0,0,0,2.2,3.157c.678.571,1.091.814,1.069.847a6.455,6.455,0,0,1-1.162-.736,8.391,8.391,0,0,1-2.362-3.155,27.555,27.555,0,0,1-1.694-6.008,26.618,26.618,0,0,0-2.384-7.771c-1.414-2.648-3.937-5.054-5.144-8.588-1.183-3.531-.367-7.561-1.79-11.251a28.072,28.072,0,0,0-3.184-5.216,16.629,16.629,0,0,1-2.69-5.972c-1.031-4.343-.647-9.026-2.192-13.347a12.813,12.813,0,0,0-1.56-2.982c-.654-.916-1.4-1.765-2.146-2.629-1.455-1.694-2.994-3.633-3.171-6.009a27.407,27.407,0,0,1,.112-3.3,11.253,11.253,0,0,0-.367-3.065,16.671,16.671,0,0,0-2.748-5.374c-2.354-3.228-5.115-5.962-7.02-9.073a14.387,14.387,0,0,1-1.985-4.874,12.931,12.931,0,0,1,0-4.852c.506-3.028,1.224-5.705.954-8.105a19.894,19.894,0,0,0-1.58-5.932c-.654-1.571-1.26-2.75-1.651-3.559-.181-.372-.33-.675-.448-.919A1.281,1.281,0,0,1,73.814,378.255Z",
    transform: "translate(-73.812 -378.255)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20995",
    "data-name": "Group 20995",
    transform: "translate(11.032 220.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20991",
    "data-name": "Group 20991",
    transform: "translate(0.852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6260",
    "data-name": "Rectangle 6260",
    width: 105.215,
    height: 18.648,
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20992",
    "data-name": "Group 20992",
    transform: "translate(8.709 14.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90815",
    "data-name": "Path 90815",
    d: "M79.718,446.312l12.794,55.726H155.22l14-55.726Z",
    transform: "translate(-79.718 -446.312)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20994",
    "data-name": "Group 20994",
    transform: "translate(0 18.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20993",
    "data-name": "Group 20993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90816",
    "data-name": "Path 90816",
    d: "M180.2,448.809c0,.2-23.732.369-53,.369s-53.006-.166-53.006-.369,23.727-.371,53.006-.371S180.2,448.6,180.2,448.809Z",
    transform: "translate(-74.195 -448.438)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(287.65 396.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21536",
    "data-name": "Group 21536",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21007",
    "data-name": "Group 21007",
    transform: "translate(269.077 351.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20997",
    "data-name": "Group 20997",
    transform: "translate(16.451 20.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90817",
    "data-name": "Path 90817",
    d: "M494.411,378.467s-35.6,16.248-70.223,16.248c-32.069,0-67.938-16.144-67.938-16.144Z",
    transform: "translate(-356.251 -378.467)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20998",
    "data-name": "Group 20998",
    transform: "translate(80.764 22.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6261",
    "data-name": "Rectangle 6261",
    width: 13.733,
    height: 143.843,
    transform: "translate(13.733 143.843) rotate(180)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20999",
    "data-name": "Group 20999",
    transform: "translate(26.064 160.082)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6262",
    "data-name": "Rectangle 6262",
    width: 121.885,
    height: 8.433,
    transform: "translate(121.885 8.433) rotate(180)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21000",
    "data-name": "Group 21000",
    transform: "translate(133.658 162.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90818",
    "data-name": "Path 90818",
    d: "M430.58,477.946a9.3,9.3,0,1,0,9.3-9.3A9.3,9.3,0,0,0,430.58,477.946Z",
    transform: "translate(-430.58 -468.646)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21001",
    "data-name": "Group 21001",
    transform: "translate(79.499 162.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90819",
    "data-name": "Path 90819",
    d: "M396.234,477.946a9.3,9.3,0,1,0,9.3-9.3A9.3,9.3,0,0,0,396.234,477.946Z",
    transform: "translate(-396.234 -468.646)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21002",
    "data-name": "Group 21002",
    transform: "translate(16.762 162.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90820",
    "data-name": "Path 90820",
    d: "M356.448,477.946a9.3,9.3,0,1,0,9.3-9.3A9.3,9.3,0,0,0,356.448,477.946Z",
    transform: "translate(-356.448 -468.646)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21003",
    "data-name": "Group 21003",
    transform: "translate(84.389 73.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6263",
    "data-name": "Rectangle 6263",
    width: 18.679,
    height: 7.73,
    transform: "translate(18.679 7.73) rotate(180)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21004",
    "data-name": "Group 21004",
    transform: "translate(99.666 68.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6264",
    "data-name": "Rectangle 6264",
    width: 6.802,
    height: 18.552,
    transform: "translate(6.802 18.552) rotate(180)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21006",
    "data-name": "Group 21006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21005",
    "data-name": "Group 21005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90821",
    "data-name": "Path 90821",
    d: "M356.142,386.02H511.693A10.323,10.323,0,0,0,522.017,375.7h0a10.323,10.323,0,0,0-10.324-10.324H356.142A10.323,10.323,0,0,0,345.818,375.7h0A10.323,10.323,0,0,0,356.142,386.02Z",
    transform: "translate(-345.818 -365.373)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21488",
    "data-name": "Group 21488",
    transform: "translate(197.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21203",
    "data-name": "Group 21203",
    transform: "translate(121.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21015",
    "data-name": "Group 21015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008",
    "data-name": "Group 21008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90822",
    "data-name": "Path 90822",
    d: "M481.159,242.723s12.52-4.882,12.008-15.559-14.9-21.236-14.047-37.266c.8-15.031-20.741-59.7-51.505-44.129,0,0-8.245-1.216-15.461.848-9.915,2.835-13.009,12.328-18.881,21.739-9.046,14.5-15.2,25.924-10.838,36.035s6.2,13.075,2.812,21.7c-4.425,11.262-8.939,7.995-7.462,17.825l26.837.437,2.536-6.557.292,7.091,15.777-.213Z",
    transform: "translate(-377.499 -142.521)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21014",
    "data-name": "Group 21014",
    transform: "translate(15.551 19.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21013",
    "data-name": "Group 21013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90823",
    "data-name": "Path 90823",
    d: "M398.957,154.585c.326,4.141-2.391,7.854-5.131,10.977s-5.79,6.375-6.366,10.489c-1.019,7.291,6.148,14.018,4.713,21.239-.768,3.87-3.918,6.992-4.463,10.9-.527,3.78,1.517,7.466,4.04,10.328s5.593,5.245,7.828,8.337c0,0,4.66,7.558,18.859,2.632",
    transform: "translate(-387.361 -154.585)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21202",
    "data-name": "Group 21202",
    transform: "translate(20.748 0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21201",
    "data-name": "Group 21201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21018",
    "data-name": "Group 21018",
    transform: "translate(0 13.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21017",
    "data-name": "Group 21017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21016",
    "data-name": "Group 21016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90824",
    "data-name": "Path 90824",
    d: "M409.245,151.245l35.377,7.495a6.609,6.609,0,0,1,6.167,6.467l-.426,76.56a23.775,23.775,0,0,1-4.986,14.438L442,260.556c-7.692,9.922-23.273,8.922-29.15-2.171a8.432,8.432,0,0,1-.814-2,15.756,15.756,0,0,1-.334-1.728l-.673-7.463c-.345-6.817-.393-13.744-.394-13.679,0,0-14.477-1.831-18.186-20.484-1.845-9.277-1.971-24.6-1.668-37.138C391.056,164.6,397.98,150.495,409.245,151.245Z",
    transform: "translate(-390.657 -151.217)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21154",
    "data-name": "Group 21154",
    transform: "translate(3.714 42.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21153",
    "data-name": "Group 21153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21052",
    "data-name": "Group 21052",
    transform: "translate(0 0.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21034",
    "data-name": "Group 21034",
    transform: "translate(1.795 6.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21033",
    "data-name": "Group 21033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21032",
    "data-name": "Group 21032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21031",
    "data-name": "Group 21031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21030",
    "data-name": "Group 21030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21029",
    "data-name": "Group 21029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21028",
    "data-name": "Group 21028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21027",
    "data-name": "Group 21027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21026",
    "data-name": "Group 21026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21025",
    "data-name": "Group 21025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21024",
    "data-name": "Group 21024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21023",
    "data-name": "Group 21023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21022",
    "data-name": "Group 21022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21021",
    "data-name": "Group 21021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21020",
    "data-name": "Group 21020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21019",
    "data-name": "Group 21019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90825",
    "data-name": "Path 90825",
    d: "M394.15,176.8a2.409,2.409,0,0,0,2.416,2.338,2.3,2.3,0,0,0,2.4-2.266,2.411,2.411,0,0,0-2.413-2.34A2.305,2.305,0,0,0,394.15,176.8Z",
    transform: "translate(-394.15 -174.535)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21051",
    "data-name": "Group 21051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21050",
    "data-name": "Group 21050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21049",
    "data-name": "Group 21049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21048",
    "data-name": "Group 21048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21047",
    "data-name": "Group 21047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21046",
    "data-name": "Group 21046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21045",
    "data-name": "Group 21045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21044",
    "data-name": "Group 21044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21043",
    "data-name": "Group 21043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21042",
    "data-name": "Group 21042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21041",
    "data-name": "Group 21041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21040",
    "data-name": "Group 21040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21039",
    "data-name": "Group 21039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21038",
    "data-name": "Group 21038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21037",
    "data-name": "Group 21037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21036",
    "data-name": "Group 21036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21035",
    "data-name": "Group 21035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90826",
    "data-name": "Path 90826",
    d: "M393.055,172.823c.309.3,2.081-1.118,4.672-1.213,2.586-.131,4.538,1.127,4.806.8.134-.145-.192-.7-1.044-1.271a6.613,6.613,0,0,0-3.863-1.028,6.354,6.354,0,0,0-3.7,1.356C393.149,172.109,392.9,172.688,393.055,172.823Z",
    transform: "translate(-393.012 -170.105)",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21086",
    "data-name": "Group 21086",
    transform: "translate(24.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21068",
    "data-name": "Group 21068",
    transform: "translate(0.414 7.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21067",
    "data-name": "Group 21067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21066",
    "data-name": "Group 21066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21065",
    "data-name": "Group 21065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21064",
    "data-name": "Group 21064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21063",
    "data-name": "Group 21063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21062",
    "data-name": "Group 21062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21061",
    "data-name": "Group 21061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21060",
    "data-name": "Group 21060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21059",
    "data-name": "Group 21059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21058",
    "data-name": "Group 21058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21057",
    "data-name": "Group 21057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21056",
    "data-name": "Group 21056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21055",
    "data-name": "Group 21055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21054",
    "data-name": "Group 21054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21053",
    "data-name": "Group 21053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90827",
    "data-name": "Path 90827",
    d: "M408.873,176.434a2.408,2.408,0,0,0,2.416,2.338,2.3,2.3,0,0,0,2.4-2.266,2.411,2.411,0,0,0-2.413-2.34A2.305,2.305,0,0,0,408.873,176.434Z",
    transform: "translate(-408.873 -174.166)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21085",
    "data-name": "Group 21085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21084",
    "data-name": "Group 21084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21083",
    "data-name": "Group 21083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21082",
    "data-name": "Group 21082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21081",
    "data-name": "Group 21081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21080",
    "data-name": "Group 21080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21079",
    "data-name": "Group 21079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21078",
    "data-name": "Group 21078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21077",
    "data-name": "Group 21077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21076",
    "data-name": "Group 21076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21075",
    "data-name": "Group 21075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21074",
    "data-name": "Group 21074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21073",
    "data-name": "Group 21073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21072",
    "data-name": "Group 21072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21071",
    "data-name": "Group 21071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21070",
    "data-name": "Group 21070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21069",
    "data-name": "Group 21069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90828",
    "data-name": "Path 90828",
    d: "M408.652,172.422c.311.3,2.085-1.118,4.674-1.211,2.584-.131,4.538,1.127,4.806.8.132-.145-.191-.7-1.044-1.271a6.622,6.622,0,0,0-3.865-1.03,6.353,6.353,0,0,0-3.7,1.358C408.75,171.71,408.5,172.288,408.652,172.422Z",
    transform: "translate(-408.61 -169.704)",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21103",
    "data-name": "Group 21103",
    transform: "translate(10.193 0.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21102",
    "data-name": "Group 21102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21101",
    "data-name": "Group 21101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21100",
    "data-name": "Group 21100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21099",
    "data-name": "Group 21099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21098",
    "data-name": "Group 21098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21097",
    "data-name": "Group 21097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21096",
    "data-name": "Group 21096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21095",
    "data-name": "Group 21095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21094",
    "data-name": "Group 21094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21093",
    "data-name": "Group 21093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21092",
    "data-name": "Group 21092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21091",
    "data-name": "Group 21091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21090",
    "data-name": "Group 21090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21089",
    "data-name": "Group 21089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21088",
    "data-name": "Group 21088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21087",
    "data-name": "Group 21087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90829",
    "data-name": "Path 90829",
    d: "M406.15,191.834c.006-.148-1.613-.364-4.236-.6-.664-.043-1.3-.15-1.424-.6a3.366,3.366,0,0,1,.364-1.977l1.761-5.112c2.438-7.276,4.175-13.249,3.881-13.343s-2.509,5.724-4.947,13q-.875,2.689-1.676,5.139a3.829,3.829,0,0,0-.243,2.61,1.662,1.662,0,0,0,1.126.926,4.576,4.576,0,0,0,1.129.112C404.516,192.033,406.146,191.981,406.15,191.834Z",
    transform: "translate(-399.476 -170.206)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21119",
    "data-name": "Group 21119",
    transform: "translate(16.267 45.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21118",
    "data-name": "Group 21118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21117",
    "data-name": "Group 21117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21116",
    "data-name": "Group 21116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21115",
    "data-name": "Group 21115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21114",
    "data-name": "Group 21114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21113",
    "data-name": "Group 21113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21112",
    "data-name": "Group 21112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21111",
    "data-name": "Group 21111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21110",
    "data-name": "Group 21110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21109",
    "data-name": "Group 21109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21108",
    "data-name": "Group 21108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21107",
    "data-name": "Group 21107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21106",
    "data-name": "Group 21106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21105",
    "data-name": "Group 21105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21104",
    "data-name": "Group 21104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90830",
    "data-name": "Path 90830",
    d: "M403.328,206.214a47.794,47.794,0,0,0,24.877-7.681s-5.816,13.238-24.669,12.21Z",
    transform: "translate(-403.328 -198.533)",
    fill: "#eb996e"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21135",
    "data-name": "Group 21135",
    transform: "translate(17.966 26.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21134",
    "data-name": "Group 21134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21133",
    "data-name": "Group 21133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21132",
    "data-name": "Group 21132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21131",
    "data-name": "Group 21131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21130",
    "data-name": "Group 21130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21129",
    "data-name": "Group 21129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21128",
    "data-name": "Group 21128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21127",
    "data-name": "Group 21127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21126",
    "data-name": "Group 21126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21125",
    "data-name": "Group 21125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21124",
    "data-name": "Group 21124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21123",
    "data-name": "Group 21123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21122",
    "data-name": "Group 21122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21121",
    "data-name": "Group 21121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21120",
    "data-name": "Group 21120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90831",
    "data-name": "Path 90831",
    d: "M404.645,188.55a4.672,4.672,0,0,1,4.116-1.9,4.261,4.261,0,0,1,3,1.465,2.7,2.7,0,0,1,.325,3.078,3.131,3.131,0,0,1-3.362.99,9.807,9.807,0,0,1-3.387-1.847,2.838,2.838,0,0,1-.769-.738.864.864,0,0,1-.033-.963",
    transform: "translate(-404.405 -186.644)",
    fill: "#eb996e"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21152",
    "data-name": "Group 21152",
    transform: "translate(16.571 23.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21151",
    "data-name": "Group 21151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21150",
    "data-name": "Group 21150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21149",
    "data-name": "Group 21149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21148",
    "data-name": "Group 21148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21147",
    "data-name": "Group 21147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21146",
    "data-name": "Group 21146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21145",
    "data-name": "Group 21145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21144",
    "data-name": "Group 21144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21143",
    "data-name": "Group 21143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21142",
    "data-name": "Group 21142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21141",
    "data-name": "Group 21141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21140",
    "data-name": "Group 21140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21139",
    "data-name": "Group 21139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21138",
    "data-name": "Group 21138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21137",
    "data-name": "Group 21137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21136",
    "data-name": "Group 21136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90832",
    "data-name": "Path 90832",
    d: "M411.51,184.87c-.423-.008-.318,2.8-2.649,4.893s-5.333,1.9-5.339,2.29c-.033.178.689.52,1.955.5a6.988,6.988,0,0,0,4.463-1.752,6.091,6.091,0,0,0,2.04-4.1C412.041,185.531,411.7,184.847,411.51,184.87Z",
    transform: "translate(-403.52 -184.87)",
    fill: "#263238"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21169",
    "data-name": "Group 21169",
    transform: "translate(28.48 35.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21168",
    "data-name": "Group 21168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21167",
    "data-name": "Group 21167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21166",
    "data-name": "Group 21166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21165",
    "data-name": "Group 21165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21164",
    "data-name": "Group 21164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21163",
    "data-name": "Group 21163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21162",
    "data-name": "Group 21162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21161",
    "data-name": "Group 21161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21160",
    "data-name": "Group 21160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21159",
    "data-name": "Group 21159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21158",
    "data-name": "Group 21158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21157",
    "data-name": "Group 21157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21156",
    "data-name": "Group 21156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21155",
    "data-name": "Group 21155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90833",
    "data-name": "Path 90833",
    d: "M408.735,167.338c.282.694,2.856.26,5.909.508,3.059.188,5.544.981,5.923.334.167-.309-.285-.956-1.3-1.6a10.311,10.311,0,0,0-9.013-.642C409.153,166.432,408.612,167.006,408.735,167.338Z",
    transform: "translate(-408.718 -165.193)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21184",
    "data-name": "Group 21184",
    transform: "translate(3.991 31.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21183",
    "data-name": "Group 21183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21182",
    "data-name": "Group 21182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21181",
    "data-name": "Group 21181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21180",
    "data-name": "Group 21180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21179",
    "data-name": "Group 21179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21178",
    "data-name": "Group 21178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21177",
    "data-name": "Group 21177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21176",
    "data-name": "Group 21176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21175",
    "data-name": "Group 21175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21174",
    "data-name": "Group 21174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21173",
    "data-name": "Group 21173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21172",
    "data-name": "Group 21172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21171",
    "data-name": "Group 21171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21170",
    "data-name": "Group 21170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90834",
    "data-name": "Path 90834",
    d: "M393.264,165.674c.479.571,2.239-.11,4.384-.222,2.141-.186,3.978.241,4.373-.389.172-.306-.137-.883-.952-1.41a6.353,6.353,0,0,0-7.055.492C393.278,164.779,393.052,165.4,393.264,165.674Z",
    transform: "translate(-393.188 -162.811)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21187",
    "data-name": "Group 21187",
    transform: "translate(16.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21186",
    "data-name": "Group 21186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21185",
    "data-name": "Group 21185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90835",
    "data-name": "Path 90835",
    d: "M454.14,163.714c-2.624-7.708-13.179-16.158-23.125-19.969a18.867,18.867,0,0,0-17.114,2.012l-12.631,8.351A17.5,17.5,0,0,0,413.4,167.252c3.225.911,7.088,1.1,9.048,3.821,2,2.775.948,6.9,2.816,9.762,2.589,3.972,9.447,3.644,11.416,7.958.861,1.884.476,4.165,1.37,6.033,1.192,2.49,7.616,5.549,10.231,4.663s2.532-5.366,3.346-7.731a12.419,12.419,0,0,0,.214-8.337C450.6,178.137,455.89,168.854,454.14,163.714Z",
    transform: "translate(-401.271 -142.544)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21193",
    "data-name": "Group 21193",
    transform: "translate(56.033 54.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21192",
    "data-name": "Group 21192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21191",
    "data-name": "Group 21191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21190",
    "data-name": "Group 21190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21189",
    "data-name": "Group 21189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21188",
    "data-name": "Group 21188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90836",
    "data-name": "Path 90836",
    d: "M426.192,182.1c-.05-1.4,1.437-4.756,2.808-5.024,3.665-.719,10.321-.68,10.745,8.679.582,12.793-12.383,10.738-12.423,10.371C427.293,195.84,426.369,186.926,426.192,182.1Z",
    transform: "translate(-426.191 -176.802)",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21200",
    "data-name": "Group 21200",
    transform: "translate(60.843 58.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21199",
    "data-name": "Group 21199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21198",
    "data-name": "Group 21198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21197",
    "data-name": "Group 21197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21196",
    "data-name": "Group 21196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21195",
    "data-name": "Group 21195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21194",
    "data-name": "Group 21194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90837",
    "data-name": "Path 90837",
    d: "M429.252,189.614c.055-.043.23.147.615.3a2.225,2.225,0,0,0,1.667-.041c1.329-.557,2.37-2.755,2.327-5.063a7.347,7.347,0,0,0-.769-3.163,2.57,2.57,0,0,0-1.753-1.634,1.139,1.139,0,0,0-1.288.669c-.154.367-.062.618-.129.643-.033.033-.284-.2-.2-.735a1.435,1.435,0,0,1,.468-.825,1.683,1.683,0,0,1,1.217-.382,3.132,3.132,0,0,1,2.417,1.878,7.568,7.568,0,0,1,.935,3.531c.035,2.581-1.175,5.054-3,5.672a2.384,2.384,0,0,1-2.053-.246C429.29,189.923,429.209,189.639,429.252,189.614Z",
    transform: "translate(-429.242 -179.381)",
    fill: "#eb996e"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21219",
    "data-name": "Group 21219",
    transform: "translate(2.151 155.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21204",
    "data-name": "Group 21204",
    transform: "translate(41.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90838",
    "data-name": "Path 90838",
    d: "M399.93,241.393l-22.623,59.021-42.575,2.7-6.587,18.506,56.207,10.895s16.9,4.914,26.54-16.538l16.475-58.708Z",
    transform: "translate(-328.145 -241.393)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21212",
    "data-name": "Group 21212",
    transform: "translate(0 44.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21207",
    "data-name": "Group 21207",
    transform: "translate(0.378 0.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21206",
    "data-name": "Group 21206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21205",
    "data-name": "Group 21205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90839",
    "data-name": "Path 90839",
    d: "M309.5,295.925a2.813,2.813,0,0,0,2.711,1.58,3.239,3.239,0,0,0,.7-.144c1.61-.516,1.459-3.8,1.459-3.8l7.716-1.258s10.034,6.468,13.6,10.757,12.675.815,12.675.815l3.157-16.445-14.2-12.842s.872.766-.107-1.637-5.442-1.493-5.442-1.493c-.694-1.187-3.609-1.613-3.609-1.613l-12.456,1.435a8.538,8.538,0,0,0-6.241,3.922l-5.267,8.338s-2.782,6-2.335,7.4a2.494,2.494,0,0,0,2.9,1.637s.612,3.947,1.649,4.084a8.5,8.5,0,0,0,3.083-.74Z",
    transform: "translate(-301.815 -269.85)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21211",
    "data-name": "Group 21211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21210",
    "data-name": "Group 21210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21209",
    "data-name": "Group 21209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21208",
    "data-name": "Group 21208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90840",
    "data-name": "Path 90840",
    d: "M333.1,300.541a4.4,4.4,0,0,1-.74-.565c-.533-.429-1.225-.984-2.086-1.675a86.844,86.844,0,0,0-8.186-5.639l.177.035c-2.3.391-4.9.833-7.706,1.312l.263-.326a8.5,8.5,0,0,1-.144,1.886,3.5,3.5,0,0,1-.875,1.854,1.906,1.906,0,0,1-1.023.47,2.716,2.716,0,0,1-1.085.063,3.153,3.153,0,0,1-1.917-1.061,3.39,3.39,0,0,1-.336-.456l-.071-.125-.035-.061-.016-.031,0,0c-.1-.038.861.314.453.166l-.008,0-.016.008-.244.1c-.326.129-.658.246-1,.353a8.824,8.824,0,0,1-1.056.263,3.888,3.888,0,0,1-.572.061,1.3,1.3,0,0,1-.714-.137,2.291,2.291,0,0,1-.755-1.02,8.228,8.228,0,0,1-.383-1.061,18.429,18.429,0,0,1-.5-2.182l.451.312a2.93,2.93,0,0,1-2.873-.981,2.373,2.373,0,0,1-.53-1.552,6.885,6.885,0,0,1,.273-1.493,41.416,41.416,0,0,1,2.126-5.546l.011-.022.014-.024,2.808-4.448q.9-1.421,1.782-2.819a15.179,15.179,0,0,1,1.954-2.73,8.3,8.3,0,0,1,2.8-1.858,10.811,10.811,0,0,1,3.176-.661l11.743-1.32.049-.006.043.008a10.982,10.982,0,0,1,2.059.542,3.5,3.5,0,0,1,1.788,1.25l-.432-.134a4.3,4.3,0,0,1,4,.224,5.024,5.024,0,0,1,1.979,3.154l-.093-.164,9.786,8.8,2.637,2.428a6.992,6.992,0,0,1,.883.891,6.741,6.741,0,0,1-.995-.763q-1.034-.87-2.741-2.312c-2.424-2.092-5.809-5.018-9.959-8.6l-.068-.058-.027-.106a4.462,4.462,0,0,0-1.746-2.739,3.671,3.671,0,0,0-3.371-.145l-.273.114-.161-.249a2.96,2.96,0,0,0-1.451-.945,10.365,10.365,0,0,0-1.919-.489h.091l-11.735,1.385a10.106,10.106,0,0,0-2.972.618,7.545,7.545,0,0,0-2.526,1.687,14.567,14.567,0,0,0-1.845,2.6l-1.78,2.821-2.811,4.445.024-.044a41.411,41.411,0,0,0-2.094,5.42,6.288,6.288,0,0,0-.251,1.317,1.61,1.61,0,0,0,.367,1.057,2.173,2.173,0,0,0,2.11.708l.388-.063.063.375a17.793,17.793,0,0,0,.462,2.088,3.78,3.78,0,0,0,.806,1.667.751.751,0,0,0,.314.035,3.09,3.09,0,0,0,.471-.05,7.628,7.628,0,0,0,.967-.235c.32-.1.639-.207.948-.326l.23-.093.013,0,.006,0c-.405-.148.558.2.459.167l0,0,.014.025.027.049.054.1a2.7,2.7,0,0,0,.262.361,2.472,2.472,0,0,0,1.487.844,2.063,2.063,0,0,0,.848-.049,1.269,1.269,0,0,0,.7-.295,4.834,4.834,0,0,0,.844-3.222l0-.285.263-.041,7.723-1.206.1-.016.079.049a74.153,74.153,0,0,1,8.1,5.868c.894.755,1.564,1.361,2,1.787A4.555,4.555,0,0,1,333.1,300.541Z",
    transform: "translate(-301.575 -269.623)",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21214",
    "data-name": "Group 21214",
    transform: "translate(3.621 50.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21213",
    "data-name": "Group 21213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90841",
    "data-name": "Path 90841",
    d: "M328.473,273.664a15.077,15.077,0,0,1-4,1.192,39.942,39.942,0,0,1-10.275.746l.412-.279c-.21.613-.434,1.26-.7,1.9a30.707,30.707,0,0,1-6.323,9.794,25.907,25.907,0,0,1-2.625,2.375c-.667.5-1.058.749-1.091.706-.087-.1,1.344-1.266,3.289-3.474a34.264,34.264,0,0,0,5.989-9.707c.255-.628.476-1.257.684-1.853l.1-.3.307.019a47.973,47.973,0,0,0,10.13-.47C326.918,273.932,328.441,273.548,328.473,273.664Z",
    transform: "translate(-303.872 -273.643)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21216",
    "data-name": "Group 21216",
    transform: "translate(7.826 58.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21215",
    "data-name": "Group 21215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90842",
    "data-name": "Path 90842",
    d: "M315.113,278.26c.2.038-.613,3.474-3.08,6.986-2.441,3.529-5.382,5.481-5.487,5.308-.161-.192,2.461-2.368,4.814-5.778C313.742,281.388,314.876,278.176,315.113,278.26Z",
    transform: "translate(-306.539 -278.258)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21218",
    "data-name": "Group 21218",
    transform: "translate(14.103 56.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21217",
    "data-name": "Group 21217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90843",
    "data-name": "Path 90843",
    d: "M345.8,294.693c.009.022-.126.1-.4.229a8.837,8.837,0,0,1-1.232.475,13.309,13.309,0,0,1-4.9.565,13.531,13.531,0,0,1-7.06-2.556,14.146,14.146,0,0,1-5.333-7.835l.456.292A31.651,31.651,0,0,1,315,285.79a10.158,10.158,0,0,1-3.176-1.044,2.505,2.505,0,0,1-1.2-1.361,2.3,2.3,0,0,1,1.6-2.886q.729-.182,1.438-.358c3.785-.918,7.232-1.572,10.138-2.03s5.273-.724,6.911-.869a13.948,13.948,0,0,1,2.555-.12,16.77,16.77,0,0,1-2.517.437c-1.623.243-3.969.6-6.851,1.124s-6.3,1.239-10.053,2.19l-1.419.369a1.522,1.522,0,0,0-.915.725,1.5,1.5,0,0,0-.131,1.173,1.724,1.724,0,0,0,.858.915,9.536,9.536,0,0,0,2.924.932,31.68,31.68,0,0,0,12.028.1l.366-.068.09.36a13.62,13.62,0,0,0,4.972,7.484,13.326,13.326,0,0,0,6.7,2.6,14.419,14.419,0,0,0,4.791-.326C345.2,294.872,345.779,294.637,345.8,294.693Z",
    transform: "translate(-310.519 -277.098)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21455",
    "data-name": "Group 21455",
    transform: "translate(0 243.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21226",
    "data-name": "Group 21226",
    transform: "translate(30.738 190.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21225",
    "data-name": "Group 21225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21224",
    "data-name": "Group 21224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21223",
    "data-name": "Group 21223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21222",
    "data-name": "Group 21222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21221",
    "data-name": "Group 21221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21220",
    "data-name": "Group 21220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90844",
    "data-name": "Path 90844",
    d: "M325.88,424.9a3.132,3.132,0,0,1,.043-1.41,9.321,9.321,0,0,1,1.424-3.586,5,5,0,0,1,.85-1.034,1.6,1.6,0,0,1,1.594-.36,1.135,1.135,0,0,1,.7.708,1.534,1.534,0,0,1-.032.957,9.736,9.736,0,0,1-.743,1.438c-.553.932-1.009,1.859-1.716,2.906a2.038,2.038,0,0,1-1.894.853,4.05,4.05,0,0,1-1.829-.81,15.8,15.8,0,0,1-2.687-2.476,16.393,16.393,0,0,1-1.058-1.38,4.558,4.558,0,0,1-.8-1.583,1.5,1.5,0,0,1,.807-1.727,1.794,1.794,0,0,1,1.7.386,10.413,10.413,0,0,1,1.794,2.033,13.646,13.646,0,0,1,1.76,3.414,3.542,3.542,0,0,1,.306,1.373,26.874,26.874,0,0,0-2.545-4.432,10.68,10.68,0,0,0-1.723-1.821,1.137,1.137,0,0,0-1.012-.268.761.761,0,0,0-.33.888,3.977,3.977,0,0,0,.7,1.279,16.14,16.14,0,0,0,1.02,1.3,15.715,15.715,0,0,0,2.556,2.334,3.318,3.318,0,0,0,1.433.661,1.188,1.188,0,0,0,1.148-.53c.588-.855,1.151-1.91,1.694-2.786a9.822,9.822,0,0,0,.711-1.285c.144-.4.065-.662-.216-.776-.645-.265-1.273.464-1.709,1.082A13.458,13.458,0,0,0,325.88,424.9Z",
    transform: "translate(-319.704 -417.308)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21454",
    "data-name": "Group 21454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21231",
    "data-name": "Group 21231",
    transform: "translate(73.46 175.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21230",
    "data-name": "Group 21230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21229",
    "data-name": "Group 21229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21228",
    "data-name": "Group 21228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21227",
    "data-name": "Group 21227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90845",
    "data-name": "Path 90845",
    d: "M346.8,431.283l18.147,39.328,29.283-13.528-18.77-48.674Z",
    transform: "translate(-346.798 -408.409)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21323",
    "data-name": "Group 21323",
    transform: "translate(73.795 218.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21322",
    "data-name": "Group 21322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21321",
    "data-name": "Group 21321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21243",
    "data-name": "Group 21243",
    transform: "translate(0.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21242",
    "data-name": "Group 21242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21241",
    "data-name": "Group 21241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21240",
    "data-name": "Group 21240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21239",
    "data-name": "Group 21239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21238",
    "data-name": "Group 21238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21237",
    "data-name": "Group 21237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21236",
    "data-name": "Group 21236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21235",
    "data-name": "Group 21235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21234",
    "data-name": "Group 21234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21233",
    "data-name": "Group 21233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21232",
    "data-name": "Group 21232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90846",
    "data-name": "Path 90846",
    d: "M361.31,452.262l10.6,20.217s-27.139,28.062-24.591,34.335l63.8-30.59L393.593,435.67Z",
    transform: "translate(-347.153 -435.67)",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21256",
    "data-name": "Group 21256",
    transform: "translate(41.132 24.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21255",
    "data-name": "Group 21255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21254",
    "data-name": "Group 21254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21253",
    "data-name": "Group 21253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21252",
    "data-name": "Group 21252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21251",
    "data-name": "Group 21251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21250",
    "data-name": "Group 21250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21249",
    "data-name": "Group 21249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21248",
    "data-name": "Group 21248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21247",
    "data-name": "Group 21247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21246",
    "data-name": "Group 21246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21245",
    "data-name": "Group 21245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21244",
    "data-name": "Group 21244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90847",
    "data-name": "Path 90847",
    d: "M375.35,451.277a2.886,2.886,0,0,1,3.226,2.108,2.775,2.775,0,0,1-2.063,3.217,3.048,3.048,0,0,1-3.406-2.252c-.155-1.411,1.1-3.171,2.517-3.108",
    transform: "translate(-373.095 -451.236)",
    fill: "#e0e0e0"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21268",
    "data-name": "Group 21268",
    transform: "translate(0 35.468)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21267",
    "data-name": "Group 21267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21266",
    "data-name": "Group 21266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21265",
    "data-name": "Group 21265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21264",
    "data-name": "Group 21264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21263",
    "data-name": "Group 21263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21262",
    "data-name": "Group 21262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21261",
    "data-name": "Group 21261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21260",
    "data-name": "Group 21260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21259",
    "data-name": "Group 21259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21258",
    "data-name": "Group 21258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21257",
    "data-name": "Group 21257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90848",
    "data-name": "Path 90848",
    d: "M411.2,463.248l-2.655-5.085-60.176,31.23s-2.249,2.6-.968,4.445Z",
    transform: "translate(-347.01 -458.163)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21281",
    "data-name": "Group 21281",
    transform: "translate(23.778 35.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21280",
    "data-name": "Group 21280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21279",
    "data-name": "Group 21279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21278",
    "data-name": "Group 21278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21277",
    "data-name": "Group 21277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21276",
    "data-name": "Group 21276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21275",
    "data-name": "Group 21275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21274",
    "data-name": "Group 21274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21273",
    "data-name": "Group 21273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21272",
    "data-name": "Group 21272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21271",
    "data-name": "Group 21271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21270",
    "data-name": "Group 21270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21269",
    "data-name": "Group 21269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90849",
    "data-name": "Path 90849",
    d: "M362.106,459.586c.159.308,1.785-.3,3.8-.032,2.02.214,3.458,1.184,3.685.924.259-.2-1.1-1.837-3.543-2.118C363.607,458.06,361.9,459.334,362.106,459.586Z",
    transform: "translate(-362.089 -458.315)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21294",
    "data-name": "Group 21294",
    transform: "translate(18.423 42.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21293",
    "data-name": "Group 21293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21292",
    "data-name": "Group 21292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21291",
    "data-name": "Group 21291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21290",
    "data-name": "Group 21290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21289",
    "data-name": "Group 21289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21288",
    "data-name": "Group 21288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21287",
    "data-name": "Group 21287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21286",
    "data-name": "Group 21286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21285",
    "data-name": "Group 21285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21284",
    "data-name": "Group 21284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21283",
    "data-name": "Group 21283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21282",
    "data-name": "Group 21282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90850",
    "data-name": "Path 90850",
    d: "M358.7,463.114c.074.336,1.676.219,3.367,1.03,1.714.76,2.663,2.058,2.968,1.9.317-.091-.344-2.02-2.463-2.987C360.46,462.065,358.565,462.814,358.7,463.114Z",
    transform: "translate(-358.694 -462.559)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21307",
    "data-name": "Group 21307",
    transform: "translate(13.444 48.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21306",
    "data-name": "Group 21306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21305",
    "data-name": "Group 21305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21304",
    "data-name": "Group 21304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21303",
    "data-name": "Group 21303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21302",
    "data-name": "Group 21302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21301",
    "data-name": "Group 21301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21300",
    "data-name": "Group 21300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21299",
    "data-name": "Group 21299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21298",
    "data-name": "Group 21298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21297",
    "data-name": "Group 21297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21296",
    "data-name": "Group 21296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21295",
    "data-name": "Group 21295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90851",
    "data-name": "Path 90851",
    d: "M360.561,470.727c.315-.069,0-1.834-1.615-3.157s-3.4-1.3-3.409-.979c-.052.341,1.332.8,2.644,1.908C359.519,469.575,360.237,470.844,360.561,470.727Z",
    transform: "translate(-355.536 -466.405)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21320",
    "data-name": "Group 21320",
    transform: "translate(20.708 25.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21319",
    "data-name": "Group 21319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21318",
    "data-name": "Group 21318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21317",
    "data-name": "Group 21317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21316",
    "data-name": "Group 21316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21315",
    "data-name": "Group 21315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21314",
    "data-name": "Group 21314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21313",
    "data-name": "Group 21313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21312",
    "data-name": "Group 21312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21311",
    "data-name": "Group 21311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21310",
    "data-name": "Group 21310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21309",
    "data-name": "Group 21309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21308",
    "data-name": "Group 21308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90852",
    "data-name": "Path 90852",
    d: "M360.186,455.363c.266.221,1.49-.894,3.308-1.619,1.8-.762,3.458-.828,3.491-1.173.073-.311-1.818-.823-3.947.061C360.9,453.5,359.916,455.191,360.186,455.363Z",
    transform: "translate(-360.142 -452.138)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21328",
    "data-name": "Group 21328",
    transform: "translate(34.367 36.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21327",
    "data-name": "Group 21327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21326",
    "data-name": "Group 21326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21325",
    "data-name": "Group 21325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21324",
    "data-name": "Group 21324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90853",
    "data-name": "Path 90853",
    d: "M369.839,513.748l-47.833-119.71s1.075-20.425,4.838-26.875,117.71-44.075,117.71-44.075,29.024-6.987,48.373,0,39.62,14.017,37.447,27.546c-3.172,19.768-20.3,40.374-20.3,40.374L426.279,393.5l-45.672,16.663,30.757,88.148Z",
    transform: "translate(-322.006 -319.984)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21333",
    "data-name": "Group 21333",
    transform: "translate(38.577 140.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21332",
    "data-name": "Group 21332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21331",
    "data-name": "Group 21331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21330",
    "data-name": "Group 21330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21329",
    "data-name": "Group 21329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90854",
    "data-name": "Path 90854",
    d: "M325.754,393.867l-1.079,43.3,32.247.788,4.646-51.96Z",
    transform: "translate(-324.675 -385.994)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21425",
    "data-name": "Group 21425",
    transform: "translate(0 187.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21424",
    "data-name": "Group 21424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21423",
    "data-name": "Group 21423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21345",
    "data-name": "Group 21345",
    transform: "translate(0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21344",
    "data-name": "Group 21344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21343",
    "data-name": "Group 21343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21342",
    "data-name": "Group 21342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21341",
    "data-name": "Group 21341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21340",
    "data-name": "Group 21340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21339",
    "data-name": "Group 21339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21338",
    "data-name": "Group 21338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21337",
    "data-name": "Group 21337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21336",
    "data-name": "Group 21336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21335",
    "data-name": "Group 21335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21334",
    "data-name": "Group 21334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90855",
    "data-name": "Path 90855",
    d: "M336.861,416.225l.588,22.822S300.71,452.244,300.227,459l70.749.717,2.176-44.126Z",
    transform: "translate(-300.227 -415.59)",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21358",
    "data-name": "Group 21358",
    transform: "translate(55.675 20.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21357",
    "data-name": "Group 21357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21356",
    "data-name": "Group 21356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21355",
    "data-name": "Group 21355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21354",
    "data-name": "Group 21354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21353",
    "data-name": "Group 21353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21352",
    "data-name": "Group 21352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21351",
    "data-name": "Group 21351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21350",
    "data-name": "Group 21350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21349",
    "data-name": "Group 21349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21348",
    "data-name": "Group 21348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21347",
    "data-name": "Group 21347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21346",
    "data-name": "Group 21346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90856",
    "data-name": "Path 90856",
    d: "M339,428.708a2.889,2.889,0,0,1,1.965,3.318A2.78,2.78,0,0,1,337.691,434a3.048,3.048,0,0,1-2.061-3.524c.484-1.334,2.386-2.361,3.63-1.678",
    transform: "translate(-335.519 -428.582)",
    fill: "#e0e0e0"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21370",
    "data-name": "Group 21370",
    transform: "translate(0 38.39)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21369",
    "data-name": "Group 21369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21368",
    "data-name": "Group 21368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21367",
    "data-name": "Group 21367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21366",
    "data-name": "Group 21366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21365",
    "data-name": "Group 21365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21364",
    "data-name": "Group 21364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21363",
    "data-name": "Group 21363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21362",
    "data-name": "Group 21362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21361",
    "data-name": "Group 21361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21360",
    "data-name": "Group 21360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21359",
    "data-name": "Group 21359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90857",
    "data-name": "Path 90857",
    d: "M370.985,445.671l-.137-5.735-67.782,1.457s-3.163,1.339-2.831,3.561Z",
    transform: "translate(-300.211 -439.936)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21383",
    "data-name": "Group 21383",
    transform: "translate(36.101 22.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21382",
    "data-name": "Group 21382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21381",
    "data-name": "Group 21381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21380",
    "data-name": "Group 21380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21379",
    "data-name": "Group 21379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21378",
    "data-name": "Group 21378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21377",
    "data-name": "Group 21377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21376",
    "data-name": "Group 21376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21375",
    "data-name": "Group 21375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21374",
    "data-name": "Group 21374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21373",
    "data-name": "Group 21373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21372",
    "data-name": "Group 21372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21371",
    "data-name": "Group 21371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90858",
    "data-name": "Path 90858",
    d: "M323.108,430.343c.008.345,1.733.519,3.422,1.648,1.719,1.083,2.58,2.589,2.9,2.455.32-.065-.175-2.134-2.244-3.464C325.129,429.634,323.035,430.025,323.108,430.343Z",
    transform: "translate(-323.106 -430.034)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21396",
    "data-name": "Group 21396",
    transform: "translate(28.648 25.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21395",
    "data-name": "Group 21395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21394",
    "data-name": "Group 21394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21393",
    "data-name": "Group 21393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21392",
    "data-name": "Group 21392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21391",
    "data-name": "Group 21391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21390",
    "data-name": "Group 21390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21389",
    "data-name": "Group 21389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21388",
    "data-name": "Group 21388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21387",
    "data-name": "Group 21387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21386",
    "data-name": "Group 21386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21385",
    "data-name": "Group 21385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21384",
    "data-name": "Group 21384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90859",
    "data-name": "Path 90859",
    d: "M318.382,432.179c-.082.333,1.408.935,2.567,2.409,1.2,1.438,1.481,3.021,1.826,3.01.323.057.583-1.963-.892-3.769C320.424,432.013,318.393,431.849,318.382,432.179Z",
    transform: "translate(-318.379 -432.042)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21409",
    "data-name": "Group 21409",
    transform: "translate(21.641 28.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21408",
    "data-name": "Group 21408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21407",
    "data-name": "Group 21407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21406",
    "data-name": "Group 21406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21405",
    "data-name": "Group 21405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21404",
    "data-name": "Group 21404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21403",
    "data-name": "Group 21403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21402",
    "data-name": "Group 21402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21401",
    "data-name": "Group 21401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21400",
    "data-name": "Group 21400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21399",
    "data-name": "Group 21399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21398",
    "data-name": "Group 21398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21397",
    "data-name": "Group 21397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90860",
    "data-name": "Path 90860",
    d: "M316.641,439.925c.314.076.812-1.645-.057-3.546s-2.476-2.67-2.624-2.384c-.2.282.84,1.309,1.528,2.881C316.213,438.428,316.3,439.887,316.641,439.925Z",
    transform: "translate(-313.935 -433.936)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21422",
    "data-name": "Group 21422",
    transform: "translate(36.798 13.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21421",
    "data-name": "Group 21421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21420",
    "data-name": "Group 21420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21419",
    "data-name": "Group 21419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21418",
    "data-name": "Group 21418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21417",
    "data-name": "Group 21417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21416",
    "data-name": "Group 21416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21415",
    "data-name": "Group 21415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21414",
    "data-name": "Group 21414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21413",
    "data-name": "Group 21413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21412",
    "data-name": "Group 21412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21411",
    "data-name": "Group 21411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21410",
    "data-name": "Group 21410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90861",
    "data-name": "Path 90861",
    d: "M323.559,425.388c.142.317,1.731-.143,3.684.008,1.955.114,3.468.784,3.65.489.2-.248-1.268-1.541-3.568-1.689C325.026,424.032,323.394,425.115,323.559,425.388Z",
    transform: "translate(-323.548 -424.179)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21430",
    "data-name": "Group 21430",
    transform: "translate(32.754 27.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21429",
    "data-name": "Group 21429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21428",
    "data-name": "Group 21428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21427",
    "data-name": "Group 21427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21426",
    "data-name": "Group 21426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90862",
    "data-name": "Path 90862",
    d: "M346.714,314.876s-19.32-1.544-21.469,19.418-4.262,118.787-4.262,118.787l45.15,3.762,6.987-99.973,72.023-30.637S359.615,312.189,346.714,314.876Z",
    transform: "translate(-320.983 -314.534)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21435",
    "data-name": "Group 21435",
    transform: "translate(128.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21434",
    "data-name": "Group 21434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21433",
    "data-name": "Group 21433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21432",
    "data-name": "Group 21432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21431",
    "data-name": "Group 21431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90863",
    "data-name": "Path 90863",
    d: "M391.379,296.812s-11.726,32.874-9.491,36.539,32.386,18.741,32.386,18.741l75.448,28.977s7.749-12.328,7.749-31.261-26.244-53-26.244-53Z",
    transform: "translate(-381.604 -296.812)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21441",
    "data-name": "Group 21441",
    transform: "translate(32.754 37.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21440",
    "data-name": "Group 21440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21439",
    "data-name": "Group 21439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21438",
    "data-name": "Group 21438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21437",
    "data-name": "Group 21437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21436",
    "data-name": "Group 21436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90864",
    "data-name": "Path 90864",
    d: "M448.714,320.891a1.708,1.708,0,0,1-.355.191l-1.071.5q-1.495.665-4.179,1.859c-3.706,1.613-9.024,3.931-15.684,6.833L373.28,353.576l.244-.344c-.686,9.876-1.426,20.542-2.19,31.575-1.835,25.794-3.527,49.577-4.866,68.393l-.024.341-.339-.028-32.892-2.887c-3.881-.363-6.927-.647-9.058-.847l-2.367-.246a4.716,4.716,0,0,1-.806-.118,5.128,5.128,0,0,1,.815.017l2.375.15,9.072.664c7.9.623,19.173,1.514,32.915,2.6l-.363.311c1.293-18.818,2.925-42.605,4.7-68.4.777-11.033,1.528-21.7,2.223-31.572l.017-.248.227-.1L427.226,329.8,443,323.183l4.231-1.736c.454-.178.817-.32,1.1-.432A1.755,1.755,0,0,1,448.714,320.891Z",
    transform: "translate(-320.983 -320.889)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21447",
    "data-name": "Group 21447",
    transform: "translate(166.415 32.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21446",
    "data-name": "Group 21446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21445",
    "data-name": "Group 21445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21444",
    "data-name": "Group 21444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21443",
    "data-name": "Group 21443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21442",
    "data-name": "Group 21442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90865",
    "data-name": "Path 90865",
    d: "M459.821,326.171a11.265,11.265,0,0,1-2.118-.579l-5.681-1.832a124.143,124.143,0,0,0-19.012-4.8,55.79,55.79,0,0,0-19.463.251,78.27,78.27,0,0,0-7.8,2.26,9.4,9.4,0,0,1,1.963-.993,34.934,34.934,0,0,1,5.708-1.848,52.354,52.354,0,0,1,19.717-.5,105.832,105.832,0,0,1,19.077,5.073c2.378.844,4.288,1.569,5.6,2.088A10.9,10.9,0,0,1,459.821,326.171Z",
    transform: "translate(-405.747 -317.437)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21453",
    "data-name": "Group 21453",
    transform: "translate(167.479 23.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21452",
    "data-name": "Group 21452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21451",
    "data-name": "Group 21451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21450",
    "data-name": "Group 21450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21449",
    "data-name": "Group 21449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21448",
    "data-name": "Group 21448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90866",
    "data-name": "Path 90866",
    d: "M448.766,312.226a55.506,55.506,0,0,0-6.6-.038c-2.031.142-4.45.454-7.142.765s-5.639.683-8.693,1.26a40.432,40.432,0,0,0-14.783,5.484,45.656,45.656,0,0,0-5.128,4.131,5.75,5.75,0,0,1,1.1-1.419,22.465,22.465,0,0,1,3.7-3.206,37.856,37.856,0,0,1,14.96-5.817c3.094-.587,6.068-.927,8.766-1.2s5.131-.52,7.2-.588a27.132,27.132,0,0,1,4.882.218A5.576,5.576,0,0,1,448.766,312.226Z",
    transform: "translate(-406.422 -311.571)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21467",
    "data-name": "Group 21467",
    transform: "translate(110.183 104.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21464",
    "data-name": "Group 21464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21460",
    "data-name": "Group 21460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21459",
    "data-name": "Group 21459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21458",
    "data-name": "Group 21458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21457",
    "data-name": "Group 21457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21456",
    "data-name": "Group 21456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90867",
    "data-name": "Path 90867",
    d: "M370.086,254.166s13.5-22.5,17.241-27.054a30.019,30.019,0,0,1,11.055-8.105,22.843,22.843,0,0,1,5.253-1.555l19.41-4.3s.035,13.247,13.914,14.067,25.569-18.516,25.569-18.516,22.425,3.468,27.789,6.227,13.8,6.265,18.438,29.5l3.256,22.729-38.665,3.573-3.7,57.455-19.175,13.355s-53.161,13.82-56.557,14.734-4.522-85.543-4.522-85.543S375.738,261.907,370.086,254.166Z",
    transform: "translate(-370.086 -208.707)",
    fill: "#03b5aa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21463",
    "data-name": "Group 21463",
    transform: "translate(18.965 35.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21462",
    "data-name": "Group 21462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21461",
    "data-name": "Group 21461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90868",
    "data-name": "Path 90868",
    d: "M388.6,231.409a8.266,8.266,0,0,0-.746,1.657c-.442,1.082-1.006,2.679-1.632,4.674a91.39,91.39,0,0,0-3.953,32.293c.126,2.088.289,3.772.457,4.929a8.056,8.056,0,0,0,.325,1.788,8.333,8.333,0,0,0-.025-1.817c-.076-1.162-.153-2.846-.21-4.924a107.5,107.5,0,0,1,3.931-32.114c.557-2,1.038-3.619,1.391-4.729A8.175,8.175,0,0,0,388.6,231.409Z",
    transform: "translate(-382.113 -231.409)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21466",
    "data-name": "Group 21466",
    transform: "translate(102.112 34.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21465",
    "data-name": "Group 21465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90869",
    "data-name": "Path 90869",
    d: "M437.4,230.544a7.223,7.223,0,0,1,.035,1.757q-.078,1.954-.192,4.765c-.2,4.217-.454,9.674-.736,15.71-.292,6.137-.61,11.694-.916,15.712-.153,2.009-.293,3.633-.415,4.754a7.22,7.22,0,0,1-.27,1.734,7.272,7.272,0,0,1-.05-1.755q.064-1.956.155-4.767c.181-4.218.416-9.679.675-15.718.292-6.137.643-11.694.979-15.709.167-2.007.322-3.63.453-4.751A7.358,7.358,0,0,1,437.4,230.544Z",
    transform: "translate(-434.842 -230.544)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21487",
    "data-name": "Group 21487",
    transform: "translate(87.895 163.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21469",
    "data-name": "Group 21469",
    transform: "translate(46.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21468",
    "data-name": "Group 21468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90870",
    "data-name": "Path 90870",
    d: "M388.466,317.019l72.8-15.846,3.365-52.035L497,246.147s-2.277,35.5-2.443,46.147c-.478,30.691-10.781,35.964-16.041,40.111s-93.322,2.277-93.322,2.277Z",
    transform: "translate(-385.197 -246.147)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21471",
    "data-name": "Group 21471",
    transform: "translate(0.379 54.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21470",
    "data-name": "Group 21470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90871",
    "data-name": "Path 90871",
    d: "M363.874,306.614a2.809,2.809,0,0,0,2.711,1.578,3.214,3.214,0,0,0,.7-.142c1.61-.517,1.459-3.8,1.459-3.8l7.717-1.26s10.032,6.47,13.6,10.757,12.675.815,12.675.815l3.155-16.444-14.2-12.842s.872.765-.107-1.637-5.442-1.495-5.442-1.495c-.7-1.187-3.609-1.613-3.609-1.613l-12.456,1.435a8.537,8.537,0,0,0-6.241,3.923l-5.268,8.337s-2.782,6-2.334,7.4a2.491,2.491,0,0,0,2.9,1.638s.613,3.945,1.649,4.084a8.525,8.525,0,0,0,3.083-.74Z",
    transform: "translate(-356.192 -280.537)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21474",
    "data-name": "Group 21474",
    transform: "translate(10.623 68.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21473",
    "data-name": "Group 21473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21472",
    "data-name": "Group 21472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90872",
    "data-name": "Path 90872",
    d: "M386.637,289.756c-.013.129-1.67-.024-4.33.091a37.788,37.788,0,0,0-10.164,1.9,36.073,36.073,0,0,0-5.242,2.241c-1.5.847-3.075,1.544-3.557,2.64a1.518,1.518,0,0,0,.136,1.485,2.127,2.127,0,0,0,.941.795,3.28,3.28,0,0,0,1.091.159c.032.019-.386.344-1.194.132a2.334,2.334,0,0,1-1.2-.831,1.989,1.989,0,0,1-.293-1.949,3.968,3.968,0,0,1,1.55-1.75c.678-.445,1.388-.9,2.181-1.325a32.245,32.245,0,0,1,5.334-2.35,32.584,32.584,0,0,1,10.407-1.712A14.292,14.292,0,0,1,386.637,289.756Z",
    transform: "translate(-362.688 -289.286)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21477",
    "data-name": "Group 21477",
    transform: "translate(12.85 75.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21476",
    "data-name": "Group 21476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21475",
    "data-name": "Group 21475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90873",
    "data-name": "Path 90873",
    d: "M386.694,294.813c-.014.235-5.082.024-11.311.388-6.23.344-11.241,1.127-11.282.894a12.454,12.454,0,0,1,3.242-.787,72.684,72.684,0,0,1,16.04-.911A12.418,12.418,0,0,1,386.694,294.813Z",
    transform: "translate(-364.101 -294.289)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21480",
    "data-name": "Group 21480",
    transform: "translate(7.916 61.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21479",
    "data-name": "Group 21479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21478",
    "data-name": "Group 21478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90874",
    "data-name": "Path 90874",
    d: "M361.19,303.77a5.682,5.682,0,0,1-.156-1.326,28.75,28.75,0,0,1-.008-3.647,15.494,15.494,0,0,1,.347-2.526,7.728,7.728,0,0,1,1.224-2.715,17.039,17.039,0,0,1,4.668-4.779,23.434,23.434,0,0,1,5.957-3.01,21.486,21.486,0,0,1,5.38-.82c1.541-.054,2.781-.021,3.638.013a4.372,4.372,0,0,1,1.331.134,40.589,40.589,0,0,1-4.934.415,23.3,23.3,0,0,0-5.2.957,24.449,24.449,0,0,0-5.726,2.966,17.043,17.043,0,0,0-4.515,4.54,9.455,9.455,0,0,0-1.616,4.876C361.286,301.86,361.362,303.775,361.19,303.77Z",
    transform: "translate(-360.971 -284.917)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21483",
    "data-name": "Group 21483",
    transform: "translate(3.67 57.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21482",
    "data-name": "Group 21482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21481",
    "data-name": "Group 21481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90875",
    "data-name": "Path 90875",
    d: "M380.735,282.6c0,.118-1.864.167-4.841.511-2.865.438-7.451.648-10.064,4.6-2.829,3.594-5.234,6.987-6.287,9.772a25.294,25.294,0,0,0-1.179,4.663,3.441,3.441,0,0,1-.073-1.321,12.572,12.572,0,0,1,.725-3.537c.957-2.938,3.348-6.459,6.194-10.071a13.533,13.533,0,0,1,2.421-2.447,8.793,8.793,0,0,1,2.931-1.377,26.609,26.609,0,0,1,5.279-.839A18.925,18.925,0,0,1,380.735,282.6Z",
    transform: "translate(-358.279 -282.45)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21486",
    "data-name": "Group 21486",
    transform: "translate(0 53.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21485",
    "data-name": "Group 21485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21484",
    "data-name": "Group 21484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90876",
    "data-name": "Path 90876",
    d: "M387.482,311.229a4.359,4.359,0,0,1-.741-.565l-2.085-1.675a86.308,86.308,0,0,0-8.187-5.639l.177.033-7.706,1.312.263-.325a8.491,8.491,0,0,1-.144,1.884,3.5,3.5,0,0,1-.875,1.854,1.907,1.907,0,0,1-1.022.47,2.689,2.689,0,0,1-1.085.065,3.152,3.152,0,0,1-1.919-1.063,3.3,3.3,0,0,1-.336-.456l-.069-.123-.035-.063-.017-.032,0,0c-.1-.038.861.312.451.166l-.008,0-.016.006-.244.1c-.325.129-.656.248-1,.353a8.468,8.468,0,0,1-1.055.263,3.923,3.923,0,0,1-.574.063,1.323,1.323,0,0,1-.714-.139,2.286,2.286,0,0,1-.755-1.02,8.3,8.3,0,0,1-.383-1.06,18.536,18.536,0,0,1-.5-2.184l.451.312a2.927,2.927,0,0,1-2.875-.979,2.383,2.383,0,0,1-.53-1.553,6.959,6.959,0,0,1,.273-1.492,41.527,41.527,0,0,1,2.127-5.547l.009-.021.014-.025c.9-1.418,1.847-2.924,2.808-4.448q.9-1.419,1.782-2.818a15.268,15.268,0,0,1,1.954-2.731,8.317,8.317,0,0,1,2.8-1.858,10.816,10.816,0,0,1,3.177-.659l11.741-1.32.05-.006.041.008a10.914,10.914,0,0,1,2.059.541,3.5,3.5,0,0,1,1.788,1.252l-.432-.136a4.306,4.306,0,0,1,4,.224,5.042,5.042,0,0,1,1.979,3.154l-.095-.162,9.788,8.8q1.644,1.516,2.635,2.428a7,7,0,0,1,.883.891,6.971,6.971,0,0,1-.995-.763l-2.741-2.31-9.959-8.6-.068-.058-.027-.1a4.444,4.444,0,0,0-1.744-2.739,3.674,3.674,0,0,0-3.373-.147l-.273.115-.159-.249a2.951,2.951,0,0,0-1.452-.945,10.211,10.211,0,0,0-1.919-.489l.091,0L370.984,282.4a10.068,10.068,0,0,0-2.974.618,7.531,7.531,0,0,0-2.526,1.686,14.713,14.713,0,0,0-1.845,2.6l-1.78,2.819c-.962,1.523-1.914,3.029-2.812,4.447l.025-.044a41.087,41.087,0,0,0-2.094,5.42,6.294,6.294,0,0,0-.252,1.315,1.618,1.618,0,0,0,.367,1.057,2.175,2.175,0,0,0,2.11.708l.388-.063.063.375a18.053,18.053,0,0,0,.462,2.088,3.763,3.763,0,0,0,.807,1.667.721.721,0,0,0,.314.035,3.133,3.133,0,0,0,.471-.049,7.9,7.9,0,0,0,.967-.235c.32-.1.637-.208.948-.328l.229-.091.014,0,.006,0c-.407-.15.557.2.457.166l0,0,.014.025.027.049.055.1a2.568,2.568,0,0,0,.262.361,2.454,2.454,0,0,0,1.487.844,2.055,2.055,0,0,0,.847-.049,1.248,1.248,0,0,0,.7-.295,4.833,4.833,0,0,0,.845-3.221v-.285l.263-.041,7.725-1.206.1-.016.079.05a74.244,74.244,0,0,1,8.1,5.866c.893.755,1.563,1.362,2,1.787A4.5,4.5,0,0,1,387.482,311.229Z",
    transform: "translate(-355.952 -280.311)",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21523",
    "data-name": "Group 21523",
    transform: "translate(0 262.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21496",
    "data-name": "Group 21496",
    transform: "translate(373.18 8.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21495",
    "data-name": "Group 21495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21494",
    "data-name": "Group 21494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21490",
    "data-name": "Group 21490",
    transform: "translate(0.126 0.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21489",
    "data-name": "Group 21489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90877",
    "data-name": "Path 90877",
    d: "M424.165,314.148H411.917v2.705l26.812,261.484h14.3Z",
    transform: "translate(-411.917 -314.148)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21493",
    "data-name": "Group 21493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21492",
    "data-name": "Group 21492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21491",
    "data-name": "Group 21491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90878",
    "data-name": "Path 90878",
    d: "M424.211,314.191s.032.476.12,1.38q.142,1.381.407,3.993c.371,3.521.913,8.676,1.612,15.318,1.424,13.3,3.483,32.537,6.033,56.371,5.161,47.632,12.312,113.627,20.282,187.173l.407-.459h-14.3l.408.371c-12.621-123.082-23.418-227.2-27.1-261.454l0,.013c-.006-1.255-.009-2-.011-2.7l-.115.115,9.24-.065,2.255-.028c.5-.008.752-.022.752-.022s-.227-.016-.714-.024l-2.23-.027c-2.042-.016-5.107-.036-9.3-.066h-.115v.117l-.011,2.7v.014c3.351,34.283,13.91,138.43,26.529,261.512l.038.371h15.125l-.05-.459c-8.11-73.641-15.387-139.725-20.64-187.42-2.651-23.785-4.79-42.981-6.271-56.255-.746-6.6-1.326-11.718-1.722-15.214q-.3-2.573-.46-3.936C424.278,314.626,424.211,314.191,424.211,314.191Z",
    transform: "translate(-411.837 -314.074)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21520",
    "data-name": "Group 21520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21500",
    "data-name": "Group 21500",
    transform: "translate(156.903 8.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21499",
    "data-name": "Group 21499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21498",
    "data-name": "Group 21498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21497",
    "data-name": "Group 21497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90879",
    "data-name": "Path 90879",
    d: "M286.929,314.147H274.681v2.772l25.52,261.36H312.78Z",
    transform: "translate(-274.681 -314.147)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21503",
    "data-name": "Group 21503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21502",
    "data-name": "Group 21502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21501",
    "data-name": "Group 21501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90880",
    "data-name": "Path 90880",
    d: "M611.9,319.906l-436.564.466-.159-11.521H611.9Z",
    transform: "translate(-175.178 -308.852)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21511",
    "data-name": "Group 21511",
    transform: "translate(35.171 8.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21506",
    "data-name": "Group 21506",
    transform: "translate(0.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21505",
    "data-name": "Group 21505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21504",
    "data-name": "Group 21504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90881",
    "data-name": "Path 90881",
    d: "M223.681,314.147H235.93v2.772l-25.52,261.36H197.831Z",
    transform: "translate(-197.831 -314.147)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21510",
    "data-name": "Group 21510",
    transform: "translate(0 3.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21509",
    "data-name": "Group 21509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21508",
    "data-name": "Group 21508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21507",
    "data-name": "Group 21507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90882",
    "data-name": "Path 90882",
    d: "M223.332,316.352s-.028.468-.107,1.356-.2,2.216-.36,3.934c-.328,3.461-.807,8.543-1.427,15.091-1.257,13.107-3.076,32.069-5.331,55.563-4.557,46.95-10.872,112-17.907,184.459l-.341-.374c3.925,0,8.146,0,12.391,0h.188l-.339.309c11.923-121.017,22.021-223.524,25.376-257.573l0,.011c0-1.285.008-2.047.009-2.772l.1.1-9.244-.055-2.255-.024c-.5-.006-.749-.019-.749-.019s.23-.013.717-.019l2.233-.022,9.3-.055h.1v.1c0,.725,0,1.487.009,2.772v0l0,0c-3.293,34.054-13.2,136.582-24.907,257.619l-.03.309h-.5c-4.245,0-8.466,0-12.391,0h-.377l.038-.374c7.151-72.544,13.571-137.667,18.2-184.67,2.338-23.453,4.226-42.383,5.532-55.466.658-6.512,1.17-11.565,1.519-15.009.177-1.7.312-2.994.405-3.885C223.272,316.786,223.332,316.352,223.332,316.352Z",
    transform: "translate(-197.482 -316.256)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21519",
    "data-name": "Group 21519",
    transform: "translate(226.229 9.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21514",
    "data-name": "Group 21514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21513",
    "data-name": "Group 21513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21512",
    "data-name": "Group 21512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90883",
    "data-name": "Path 90883",
    d: "M330.894,314.784H318.645v2.762l25.52,260.367h12.579Z",
    transform: "translate(-318.645 -314.784)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21518",
    "data-name": "Group 21518",
    transform: "translate(0.445 3.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21517",
    "data-name": "Group 21517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21516",
    "data-name": "Group 21516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21515",
    "data-name": "Group 21515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90884",
    "data-name": "Path 90884",
    d: "M331.282,316.982s.03.465.107,1.35.2,2.206.36,3.918c.328,3.449.807,8.512,1.427,15.035,1.257,13.055,3.076,31.946,5.331,55.35,4.557,46.771,10.872,111.574,17.908,183.759l.339-.374H344.176l.341.308c-11.924-120.556-22.023-222.676-25.378-256.594l0,.009c0-1.279-.008-2.039-.009-2.761l-.1.1,9.244-.055,2.255-.022c.5-.008.749-.019.749-.019s-.229-.013-.717-.019l-2.233-.024-9.3-.054-.1,0,0,.1c0,.722,0,1.482-.009,2.761v0l0,.006c3.292,33.925,13.2,136.061,24.907,256.64l.03.308h.5c4.245,0,8.466,0,12.391,0h.377l-.038-.372c-7.151-72.268-13.571-137.143-18.2-183.968-2.339-23.364-4.226-42.222-5.532-55.257-.658-6.486-1.17-11.521-1.518-14.95q-.265-2.538-.405-3.87C331.342,317.414,331.282,316.982,331.282,316.982Z",
    transform: "translate(-318.927 -316.884)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21522",
    "data-name": "Group 21522",
    transform: "translate(41.931 10.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21521",
    "data-name": "Group 21521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90885",
    "data-name": "Path 90885",
    d: "M594.927,316.052c0-.218-88.019-.394-196.57-.394-108.589,0-196.588.177-196.588.394s88,.394,196.588.394C506.908,316.446,594.927,316.27,594.927,316.052Z",
    transform: "translate(-201.769 -315.658)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21535",
    "data-name": "Group 21535",
    transform: "translate(155.221 181.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21529",
    "data-name": "Group 21529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21525",
    "data-name": "Group 21525",
    transform: "translate(0.105 0.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21524",
    "data-name": "Group 21524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90886",
    "data-name": "Path 90886",
    d: "M279.974,257.51l95.889.779c3.111,0,6.084,1.495,6.549,4.57l10.48,69.888h49.391a2.879,2.879,0,0,1,0,5.759H284.534l-10.781-73.761A6.293,6.293,0,0,1,279.974,257.51Z",
    transform: "translate(-273.681 -257.51)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21528",
    "data-name": "Group 21528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21527",
    "data-name": "Group 21527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21526",
    "data-name": "Group 21526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90887",
    "data-name": "Path 90887",
    d: "M280.013,257.524a5.074,5.074,0,0,0-1.511.142,6.34,6.34,0,0,0-4.849,5.489,17.821,17.821,0,0,0,.353,3.945c.4,2.824.864,6.076,1.383,9.732,2.111,14.652,5.152,35.77,8.892,61.73l.036.254h.255l153.041.091h4.119a3.983,3.983,0,0,0,2.179-.415,3.268,3.268,0,0,0-.014-5.713,4,4,0,0,0-2.16-.405h-2.029l-16.029,0c-10.557,0-20.84.006-30.749.011l.369.317c-3.772-25.03-7.29-48.378-10.447-69.324a5.431,5.431,0,0,0-1.774-3.652,7.136,7.136,0,0,0-3.666-1.618,31.9,31.9,0,0,0-3.868-.136q-1.9-.014-3.764-.025l-14.436-.1-25.656-.162-36.525-.188-9.772-.017-2.523.013c-.566,0-.856.025-.856.025s.29.025.856.039l2.523.054c2.244.031,5.525.08,9.77.14,8.545.1,20.957.233,36.523.407l25.656.254,14.436.137,3.766.036a31.4,31.4,0,0,1,3.772.137,6.516,6.516,0,0,1,3.343,1.476,4.768,4.768,0,0,1,1.56,3.274c3.125,20.95,6.61,44.3,10.344,69.338l.047.319h.322l30.749.011,16.029,0h2.029a3.229,3.229,0,0,1,1.787.311,2.494,2.494,0,0,1,.01,4.36,3.212,3.212,0,0,1-1.8.315h-4.119l-153.041.091.293.252c-3.848-25.946-6.978-47.049-9.149-61.693-.549-3.652-1.036-6.9-1.46-9.721a17.818,17.818,0,0,1-.391-3.885,6.16,6.16,0,0,1,1.113-2.982,6.271,6.271,0,0,1,3.543-2.444A12.253,12.253,0,0,1,280.013,257.524Z",
    transform: "translate(-273.614 -257.486)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21531",
    "data-name": "Group 21531",
    transform: "translate(52.407 33.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21530",
    "data-name": "Group 21530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90888",
    "data-name": "Path 90888",
    d: "M318.857,284.825a6,6,0,1,1-6-6A6,6,0,0,1,318.857,284.825Z",
    transform: "translate(-306.849 -278.822)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21534",
    "data-name": "Group 21534",
    transform: "translate(102.283 0.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21533",
    "data-name": "Group 21533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21532",
    "data-name": "Group 21532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90889",
    "data-name": "Path 90889",
    d: "M351.627,337.576c-.136.022-3.188-17.774-6.817-39.743s-6.46-39.806-6.326-39.828,3.187,17.77,6.818,39.748S351.762,337.554,351.627,337.576Z",
    transform: "translate(-338.479 -258.004)",
    fill: "#263238"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanar);
export default __webpack_public_path__ + "static/media/Banar.d549d84d37e41f0c8e663d9e305109bd.svg";
export { ForwardRef as ReactComponent };